<template>
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        {{actionToBePerformed === 'Create Opportunity' ? 'Create Campaign' : 'Update Campaign'}}
      </h1>
      <ol class="breadcrumb">
        <li><a href="#"><i class="fa fa-dashboard"></i> Home</a></li>
        <li>
          <router-link to="/opportunity-list">Back</router-link>
        </li>
        <li class="active">Create / Update Campaign</li>
      </ol>
    </section>
    <section class="content" style="overflow:auto">
      <div class="col-xs-12 col-md-12 col-lg-12">
        <div class="box">
          <div class="box-body  oe-content-container">
            <div class="col-xs-12 col-md-12 col-lg-12 oe-content-container">
              <form>
                <div class="panel panel-default">
                  <div class="panel-heading">
                    <h3 class="panel-title">Step 1 | Name your campaign
                        <span class="text-red">*</span>
                    </h3>
                  </div>
                  <div class="panel-body" id="content-step-one">
                    <div class="row">
                      <div class="col-md-12 col-lg-12 col-xs-12">
                        <div class="form-group col-xs-4 col-sm-4 col-md-4 ">
                          <input type="text" autocomplete="off"
                            v-bind:class="{'form-group--error': submitted && !$v.formDataObj.opportunity_name.required }"
                            v-model="formDataObj.opportunity_name" class="form-control required" id="opportunity_name"
                            placeholder="Campaign Name" />
                          <span v-if="submitted && !$v.formDataObj.opportunity_name.
                          required" class="text-red pull-right">Please enter campaign name.</span>
                        </div>
                        <div class="form-group col-xs-4 col-sm-4 col-md-4">
                          <nv-select v-model="formDataObj.country_id"
                            class="form-control"
                            v-bind:class="{ 'form-group--error': submitted && !$v.formDataObj.country_id.required }"
                            @change="handleCountryChange">
                            <option value="">--Choose Country--</option>
                            <option v-for="(value, key) in clientCountries" :key="key" :value="value">
                              {{key}}
                            </option>
                          </nv-select>
                          <span v-if="(submitted && !$v.formDataObj.country_id.required)"
                            class="text-red pull-right">Please choose a country.</span>
                        </div>
                        <div class="form-group col-xs-4 col-sm-4 col-md-4">
                          <nv-select class="form-control required"
                            v-bind:class="{'form-group--error': submitted && !$v.formDataObj.customer_id.required }"
                            id="Client" v-model="formDataObj.customer_id">
                            <option value=''>--Choose a Customer--</option>
                            <option v-for="(data, index) in filteredClientList" :key="index" :value="data.id">{{data.name}}
                            </option>
                          </nv-select>
                          <span v-if="submitted && !$v.formDataObj.customer_id.required"
                            class="text-red pull-right">Please choose a customer.</span>
                        </div>
                        <div class="form-group col-xs-6 col-sm-6 col-md-6">
                          <label for="Opportunity Type">Campaign Type</label>
                          <div v-for="opportunityTypeOption in opportunityTypeOptions" :key="opportunityTypeOption.value">
                            <label class="radio-inline col-xs-4 col-sm-4 col-md-4 col-lg-4"  v-bind:class="{'reengagement-group-disabled': isOETypeDisabled }">
                              <input type="radio" :disabled="isOETypeDisabled" v-model="opportunityType" :value="opportunityTypeOption.value"
                                @change="onOpportunityTypeChange" />{{opportunityTypeOption.label}}
                            </label>
                          </div>
                        </div>
                      </div>
                      <div v-if="!isInSessionOE" class="col-md-12 col-lg-12 col-xs-12">
                        <div class="form-group col-xs-6 col-sm-6 col-md-6">
                          <label for="Campaign Goal">Campaign Goal (Went to destination)</label> 
                          <div class="v-autocomplete">
                            <treeselect
                              v-bind:class="{ 'form-group--error': submitted && !$v.formDataObj.destination_conversation.required }"
                              :options="conversationList" placeholder="--Choose Campaign Goal--" :multiple="false"
                              v-model="formDataObj.destination_conversation" />
                            <span v-if="(submitted && !$v.formDataObj.destination_conversation.required)"
                              class="text-red pull-right">Please choose a destination</span>
                          </div>
                        </div>
                        <div class="form-group col-xs-6 col-sm-6 col-md-6" style="margin-top: 30px">
                            <label class="checkbox-inline">
                              <input type="checkbox" v-model="formDataObj.isNewUserBatch" />
                                <b>is New User Batch</b>
                                <span title="Please check if users are added manually"><i class="fa fa-info-circle margin-10"></i></span>
                            </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="panel panel-default">
                  <div class="panel-heading">
                    <h3 class="panel-title">
                      Step 2 | Select Audience<span class="text-red">*</span> 
                      <label class="hint-text">If you want to resume Journey, Destination MUST be Keyword = resume_replay</label>
                    </h3>
                  </div>
                  <div class="panel-body" id="content-step-two">
                    <div class="row">
                      <div class="col-md-12 col-lg-12 col-xs-12">
                        <div class="form-group col-xs-6 col-sm-6 col-md-6" style="z-index:10">
                          <nv-select :disabled="!!formDataObj.conversation_id" class="form-control required"
                            v-bind:class="{'form-group--error': submitted && !$v.formDataObj.audience_id.required }"
                            id="audience-type-builder" v-model="formDataObj.audience_id" @change="updateAudienceType">
                            <option value="">--Choose an Audience--</option>
                            <option v-for="(data, index) in filteredAudienceList" :key="index" :value="data.id">
                              {{data.query_name}}</option>
                          </nv-select>
                          <span v-if="submitted && !$v.formDataObj.audience_id.required"
                            class="text-red pull-right">Please choose an audience.</span>
                        </div>
                        <div class="audience-or-journey">OR</div>
                        <div class="form-group col-xs-6 col-sm-6 col-md-6">
                          <nv-select :disabled="!!formDataObj.audience_id" class="form-control required"
                            v-bind:class="{'form-group--error': submitted && !$v.formDataObj.conversation_id.required }"
                            id="audience-type-journey" v-model="formDataObj.conversation_id" @change="updateAudienceType">
                            <option value="">--Choose a journey--</option>
                            <option v-for="(data, index) in journeyList" :key="index" :value="data.id">{{data.label}}
                            </option>
                          </nv-select>
                          <span v-if="submitted && !$v.formDataObj.conversation_id.required"
                            class="text-red pull-right">Please choose a journey.</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="panel panel-default">
                  <div class="panel-heading">
                    <h3 class="panel-title style-title">
                      Step 3 | Create Message &amp; Destination<span class="text-red">*</span>
                      <small v-if="turnCountry" style="margin-left: 10px">Nudge templates from <b>{{turnCountry}}</b></small>
                      <div class="style-new-icon">
                        <i class="fa fa-gift" v-on:click="showInfoPopUp" style="font-size:22px;" aria-hidden="true" title="New Features!"></i>
                      </div>
                        <label class="hint-text">If destination is keyword/conversation continue, make sure to add
                          text like type 1, type 2 for different destination</label>
                    </h3>
                  </div>
                  <div v-if="isInSessionOE">
                    <div class="panel-body" id="content-step-three">
                      <div class="row">
                        <div class="col-md-12 col-lg-12 col-xs-12">
                          <div class="form-group col-xs-12 col-sm-12 col-md-12">
                            <div v-for="splitOptn in splitOptions" :key="splitOptn.value">
                              <label class="radio-inline col-xs-4 col-sm-4 col-md-2 col-lg-2">
                                <input type="radio" v-model="split_type" :value="splitOptn.value"
                                  @change="onSplitTypeChange" />{{splitOptn.label}}
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row" style="margin-top: 15px;">
                        <div class="col-md-12 col-lg-12 col-xs-12">
                          <div class="form-group col-xs-12 col-sm-12 col-md-12">
                            <div style="font-weight: bold; margin-right: 20px">
                              <button type="button" class="btn btn-primary btn-rounded btn-nudge" @click="addGroup"><i
                                  class="fa fa-plus" aria-hidden="true"></i></button> Add New Group
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-for="(item, index) in groupList" :key="index">
                        <div class="panel panel-default panel-group-container">
                          <div class="panel-heading">
                            <a :href="'#content-group-'+index" data-toggle="collapse" class="collapsable-link-panel">
                              <h3 class="panel-title group-title">Group {{index + 1}}
                                <div class="remove-group-btn-container"
                                  v-if="actionToBePerformed !== 'Update Opportunity' && index"  v-on:click.stop.prevent="removeGroup(index)">
                                  <button type="button"
                                    class="btn btn-rounded btn-remove-nudge btn-nudge btn-danger col-xs-2 col-sm-2 col-md-2 col-2"
                                    style="margin-right: 5px;">
                                    <i class="fa fa-minus" aria-hidden="true"></i>
                                  </button>
                                  Remove Group
                                </div>
                              </h3>
                            </a>
                          </div>
                          <div class="panel-body" :id="'content-group-'+index">
                            <div class="row">
                              <div class="col-md-12 col-lg-12 col-xs-12">
                                                
                              <div class="message-set-container" v-if="item.message && item.message.length">
                                <label for="Message Sets">Message Set</label>
                                <table class='fixed-table'>
                                  <tr :key="index" v-for="(langObj, index) in item.message">
                                    <td class='message-country'><h4>{{langObj.country}}</h4></td>
                                    <td class='message-language'><h4>{{langObj.language}}</h4></td>
                                    <td><textarea-autosize v-model="langObj.message" class="form-control" style="min-height: 50px; rows=1" placeholder="Enter the message" /></td>                                                   
                                  </tr>
                                </table>
                              </div>
                                <div class="col-xs-6 col-sm-6 col-md-6">
                                  <div class="col-md-12 col-lg-12 col-xs-12">
                                    <div class="form-group col-xs-12 col-sm-12 col-md-12">
                                      <div class="destination-button" style="font-weight: bold">
                                        <button type="button" class="btn btn-primary btn-rounded btn-nudge"
                                          @click="addDestination(index)"><i class="fa fa-plus"
                                            aria-hidden="true"></i></button>
                                        Add Option
                                      </div>
                                    </div>
                                    <div class="col-md-12 col-lg-12 col-sm-12 col-xs-12"
                                      style="margin-left: -30px; margin-top: -10px;">
                                      <span v-if="(submitted && !item.destinationList.length)" class="text-red">Please
                                        Choose at least one destination.</span>
                                    </div>

                                  </div>
                                </div>
                                <div class="form-group col-xs-6 col-sm-6 col-md-6">
                                  <label>Split (%)</label>
                                  <input type="text"
                                    v-bind:class="{'form-group--error': submitted && (!$v.groupList.$each[index].split_percent.required || !$v.groupList.$each[index].split_percent.minValue || !$v.groupList.$each[index].split_percent.maxValue || !$v.groupList.$each[index].split_percent.numeric)}"
                                    v-model="item.split_percent" :disabled="split_type === 'EQUAL'" autocomplete="off"
                                    class="form-control" id="opportunity_name"
                                    placeholder="Split Percentage out of 100" />
                                  <span v-if="submitted && !$v.groupList.$each[index].split_percent.required"
                                    class="text-red pull-left">Please enter split percentage.</span>
                                  <span
                                    v-if="submitted && (!$v.groupList.$each[index].split_percent.minValue || !$v.groupList.$each[index].split_percent.maxValue)"
                                    class="text-red pull-left">Please enter number between 0 to 100.</span>
                                  <span v-if="submitted && !$v.groupList.$each[index].split_percent.numeric"
                                    class="text-red pull-left">Please enter valid integer value.</span>
                                </div>
                              </div>
                            </div>
                            <div v-for="(destination, destinationIndex) in item.destinationList"
                              :key="destinationIndex">
                              <div class="row">
                                <div class="col-md-12 col-lg-12 col-xs-12">
                                  <div class="form-group col-xs-5 col-sm-5 col-md-5">
                                    <label>Option Destination <span
                                        :title="'Please select only links OR (conversation & keyword) as destination option for single group'"><i
                                          class="fa fa-info-circle margin-10"></i></span></label>
                                    <div class="row">
                                      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <label class="radio-inline">
                                          <input v-model="destination.destinationToUse" type="radio" value="keyword"
                                            :name="'destinationToUse' + index + '' + destinationIndex">Use Keyword
                                        </label>
                                        <label class="radio-inline">
                                          <input v-model="destination.destinationToUse" type="radio"
                                            value="destination_conversation"
                                            :name="'destinationToUse' + index + '' + destinationIndex">Use
                                          Conversation
                                        </label>
                                        <label class="radio-inline">
                                          <input v-model="destination.destinationToUse" type="radio"
                                            value="website_link"
                                            :name="'destinationToUse' + index + '-' + destinationIndex">Website Link
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div v-if="(item.destinationList.length > 1)" class="form-group col-xs-1  col-sm-1 col-md-1" style="margin-top: 10px;">
                                    <div class="remove-group-btn-container" style="direction: rtl; margin-right: 20px;">
                                      <button type="button"
                                        class="btn btn-rounded btn-remove-nudge btn-nudge btn-danger col-xs-2 col-sm-2 col-md-2 col-2"
                                        style="margin-right: 5px;" @click="removeDestination(index, destinationIndex)">
                                        <i class="fa fa-minus" aria-hidden="true"></i>
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="row">
                                <div class="col-md-6 col-lg-6 col-xs-6">
                                  <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-12"
                                    v-show="destination.destinationToUse === 'keyword'">
                                    <div class="form-group">
                                      <div class="v-autocomplete">
                                        <div class="reload-dbm">
                                        <treeselect
                                          v-bind:class="{'form-group--error': (submitted && isInSessionOE && destination.destinationToUse === 'keyword' && !$v.groupList.$each[index].destinationList.$each[destinationIndex].keyword_id.required) }"
                                          :options="filteredKeywords" placeholder="--Choose a Keyword--" :multiple="false"
                                          @select="onDestinationchange(item, destinationIndex)"
                                          v-model="destination.keyword_id" 
                                          style="margin-right: 20px"/>
                                          <div class="refresh-conversation-keyword">
                                            <a href="#"><div title="Click to refresh the contents of the list" class="fa fa-refresh rotate" @click="getConversationAndJourneysAndKeywords()"></div></a>
                                          </div>
                                        </div>
                                      </div>
                                      <span
                                        v-if="(submitted && isInSessionOE && destination.destinationToUse === 'keyword' && !$v.groupList.$each[index].destinationList.$each[destinationIndex].keyword_id.required)"
                                        class="text-red pull-right">Please
                                        choose a keyword.</span>
                                    </div>
                                  </div>
                                  <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-12"
                                    v-show="destination.destinationToUse === 'destination_conversation'">
                                    <div class="form-group">
                                      <div class="v-autocomplete">
                                        <div class="reload-dbm-conversation">
                                        <treeselect
                                          v-bind:class="{'form-group--error': (submitted && isInSessionOE && destination.destinationToUse === 'destination_conversation' && !!$v.groupList.$each[index].destinationList.$each[destinationIndex].required) }"
                                          :options="conversationList" placeholder="--Choose a Conversation--"
                                          @select="onDestinationchange(item, destinationIndex)" :multiple="false"
                                          v-model="destination.conversation_id" />
                                          <div class="refresh-conversation">
                                            <a href="#"><div title="Click to refresh the contents of the list" class="fa fa-refresh rotate" @click="getConversationAndJourneysAndKeywords()"></div></a>
                                          </div>
                                        </div>
                                      </div>
                                      <span
                                        v-if="(submitted && isInSessionOE && destination.destinationToUse === 'destination_conversation' && !$v.groupList.$each[index].destinationList.$each[destinationIndex].conversation_id.required)"
                                        class="text-red pull-right">Please choose a conversation.</span>
                                    </div>
                                  </div>
                                  <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-12"
                                    v-show="destination.destinationToUse === 'website_link'">
                                    <div class="form-group">
                                      <nv-select v-model="destination.website_link" class="form-control"
                                        @change="onDestinationchange(item, destinationIndex)"
                                        v-bind:class="{'form-group--error': (submitted && isInSessionOE  && destination.destinationToUse === 'website_link' && !$v.groupList.$each[index].destinationList.$each[destinationIndex].website_link.required) }">
                                        <option value="">--Choose a Link--</option>
                                        <option v-for="(value, key) in urlList" :key="key" :value="value.id">
                                          {{value.name}}
                                        </option>
                                      </nv-select>
                                      <span
                                        v-if="(submitted && isInSessionOE && destination.destinationToUse === 'website_link' && !$v.groupList.$each[index].destinationList.$each[destinationIndex].website_link.required)"
                                        class="text-red pull-right">Please
                                        choose website link.</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-else>
                    <div class="panel-body" id="content-step-three">
                      <div class="row">
                        <div class="col-md-12 col-lg-12 col-xs-12">
                          <div class="form-group col-xs-12 col-sm-12 col-md-12">
                            <div v-for="splitOptn in splitOptions" :key="splitOptn.value">
                              <label class="radio-inline col-xs-4 col-sm-4 col-md-2 col-lg-2">
                                <input type="radio" v-model="split_type" :value="splitOptn.value" @change="onSplitTypeChange"/>{{splitOptn.label}}
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row" style="margin-top: 15px;">
                        <div class="col-md-12 col-lg-12 col-xs-12">
                          <div class="form-group col-xs-12 col-sm-12 col-md-12">
                            <div style="font-weight: bold">
                            <button type="button" class="btn btn-primary btn-rounded btn-nudge" @click="addGroup"><i class="fa fa-plus" aria-hidden="true"></i></button> Add New Group
                          </div>
                          </div>
                        </div>
                      </div>
                      <div v-for="(item, index) in groupList" :key="index">
                          <div class="panel panel-default panel-group-container">
                            <div class="panel-heading">
                              <h3 class="panel-title group-title">Group {{index + 1}}
                                <div v-if="actionToBePerformed !== 'Update Opportunity' && index" class="remove-group-btn-container">
                                  <button type="button" class="btn btn-rounded btn-remove-nudge btn-nudge btn-danger col-xs-2 col-sm-2 col-md-2 col-2" 
                                    style="margin-right: 5px;" @click="removeGroup(index)">
                                    <i class="fa fa-minus" aria-hidden="true"></i>
                                  </button>
                                  Remove Group
                              </div>
                              </h3>    
                            </div>
                            <div class="panel-body" :id="'content-group-'+index">                                
                              <div class="row">
                              <div class="col-md-12 col-lg-12 col-xs-12">
                                <div class="form-group col-xs-6 col-sm-6 col-md-6">
                                  <label >Nudge</label><span class="text-red">*</span>
                                  <div>
                                  <div class="col-xs-10 col-sm-10 col-md-10" style="padding-left: 0px;">
                                  <treeselect
                                    v-bind:class="{'form-group--error': submitted && (!$v.groupList.$each[index].msg_template_id.required || !checkIfNudgeConfigurationValid(item)) }"
                                    placeholder="--Choose a nudge--" 
                                    :multiple="false" 
                                    :options="nudgesList" 
                                    @select="onNudgechange(item, item.msg_template_id)"
                                    v-model="item.msg_template_id" />
                                    <span v-if="submitted && !$v.groupList.$each[index].msg_template_id.required" class="text-red pull-right">Please choose a nudge.</span>
                                    <span v-if="submitted && !checkIfNudgeConfigurationValid(item)" class="text-red pull-right">Please configure dynamic nudge.</span>
                                  </div>
                                  <div v-if="item.msg_template_id" class="col-xs-2 col-sm-2 col-md-2" style="padding: 0px; margin-left: -15px;">
                                    <button type="button" class="btn btn-link" @click="onNudgePreviewClick(index, item.msg_template_id)">{{isDynamicTemplate(item.msg_template_id) ? 'Configure' : 'Preview'}}</button>
                                  </div>
                                  </div>
                                </div>
                                <div class="form-group col-xs-6 col-sm-6 col-md-6">
                                <label>Split (%)</label>
                                <input type="text"
                                  v-bind:class="{'form-group--error': submitted && (!$v.groupList.$each[index].split_percent.required || !$v.groupList.$each[index].split_percent.minValue || !$v.groupList.$each[index].split_percent.maxValue || !$v.groupList.$each[index].split_percent.numeric)}"
                                  v-model="item.split_percent" :disabled="split_type === 'EQUAL'" autocomplete="off"
                                  class="form-control" id="opportunity_name"
                                  placeholder="Split Percentage out of 100" />
                                <span v-if="submitted && !$v.groupList.$each[index].split_percent.required"
                                  class="text-red pull-left">Please enter split percentage.</span>
                                <span
                                  v-if="submitted && (!$v.groupList.$each[index].split_percent.minValue || !$v.groupList.$each[index].split_percent.maxValue)"
                                  class="text-red pull-left">Please enter number between 0 to 100.</span>
                                <span v-if="submitted && !$v.groupList.$each[index].split_percent.numeric"
                                  class="text-red pull-left">Please enter valid integer value.</span>
                              </div>
                              </div>
                              <div class="form-group col-xs-12 col-sm-12 col-md-12" style="margin-left: 15px">
                                    <label class="checkbox-inline">
                                      <input type="checkbox" @change="checkDestinationOptions(item.is_intermediate_message, item.destinationList)" v-model="item.is_intermediate_message" />
                                        <b>Present User With Another Question After Nudge</b>
                                        <span title="Checking this option will allow the creator of this campaign to send another question to the user. This question may be configured with one or more options. NOTE - This functionality has been created because the nudge itself asks the users press 1 to continue."><i class="fa fa-info-circle margin-10"></i></span>
                                    </label>
                                </div>
                            </div>

                              <div class="message-set-container" v-if="item.message && item.message.length && item.is_intermediate_message">
                                <label for="Message Sets">Message Set</label>
                                <table class='fixed-table'>
                                  <tr :key="index" v-for="(langObj, index) in item.message">
                                    <td class='message-country'><h4>{{langObj.country}}</h4></td>
                                    <td class='message-language'><h4>{{langObj.language}}</h4></td>
                                    <td><textarea-autosize v-model="langObj.message" class="form-control" style="min-height: 50px; rows=1" placeholder="Enter the message" /></td>
                                  </tr>
                                </table>
                              </div>
                              <div class="row">
                                <div class="col-md-12 col-lg-12 col-xs-12">
                                  <div class="col-xs-6 col-sm-6 col-md-6">
                                    <div class="col-md-12 col-lg-12 col-xs-12">
                                      <div class="form-group col-xs-12 col-sm-12 col-md-12">
                                        <div class="destination-button" style="font-weight: bold">
                                          <button type="button" class="btn btn-primary btn-rounded btn-nudge"
                                            @click="addDestination(index)"><i class="fa fa-plus"
                                              aria-hidden="true"></i></button>
                                          Add Option
                                        </div>
                                      </div>
                                      <div class="col-md-12 col-lg-12 col-sm-12 col-xs-12"
                                        style="margin-left: -30px; margin-top: -10px;">
                                        <span v-if="(submitted && !item.destinationList.length)" class="text-red">Please
                                          Choose at least one destination.</span>
                                      </div>

                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div v-for="(destination, destinationIndex) in item.destinationList" :key="destinationIndex">
                                <div class="row">
                                  <div class="col-md-12 col-lg-12 col-xs-12">
                                    <div class="form-group col-xs-5 col-sm-5 col-md-5">
                                      <label>Option Destination 
                                        <span :title="'Please select conversation or keyword as destination option for single group'">
                                          <i class="fa fa-info-circle margin-10"></i>
                                        </span>
                                      </label>
                                      <div class="row">
                                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                          <label class="radio-inline">
                                            <input v-model="destination.destinationToUse" type="radio" value="keyword"
                                              :name="'destinationToUse' + index + '' + destinationIndex">Use Keyword
                                          </label>
                                          <label class="radio-inline">
                                            <input v-model="destination.destinationToUse" type="radio"
                                              value="destination_conversation"
                                              :name="'destinationToUse' + index + '' + destinationIndex">Use Conversation
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                    <div v-if="(item.destinationList.length > 1)" class="form-group col-xs-1  col-sm-1 col-md-1" style="margin-top: 10px;">
                                      <div class="remove-group-btn-container" style="direction: rtl; margin-right: 20px;">
                                        <button type="button"
                                          class="btn btn-rounded btn-remove-nudge btn-nudge btn-danger col-xs-2 col-sm-2 col-md-2 col-2"
                                          style="margin-right: 5px;" @click="removeDestination(index, destinationIndex)">
                                          <i class="fa fa-minus" aria-hidden="true"></i>
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div>
                                  <div class="row">
                                    <div class="col-md-6 col-lg-6 col-xs-6">
                                      <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-12"
                                        v-show="destination.destinationToUse === 'keyword'">
                                        <div class="form-group">
                                          <div class="v-autocomplete">
                                            <div class="reload-dbm">
                                            <treeselect
                                              v-bind:class="{'form-group--error': (submitted && !isInSessionOE && destination.destinationToUse === 'keyword' 
                                              && !$v.groupList.$each[index].destinationList.$each[destinationIndex].keyword_id.required) }"
                                              :options="filteredKeywords" placeholder="--Choose a Keyword--" :multiple="false"
                                              @select="onDestinationchange(item, destinationIndex)"
                                              v-model="destination.keyword_id" />
                                              <div class="refresh-conversation-keyword">
                                                <a href="#"><div title="Click to refresh the contents of the list" class="fa fa-refresh rotate" @click="getConversationAndJourneysAndKeywords()"></div></a>
                                             </div>
                                             </div>
                                          </div>
                                          <span
                                            v-if="(submitted && !isInSessionOE && destination.destinationToUse === 'keyword' && !$v.groupList.$each[index].destinationList.$each[destinationIndex].keyword_id.required)"
                                            class="text-red pull-right">Please
                                            choose a keyword.</span>
                                        </div>
                                      </div>
                                      <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-12"
                                        v-show="destination.destinationToUse === 'destination_conversation'">
                                        <div class="form-group">
                                          <div class="v-autocomplete">
                                            <div class="reload-dbm-conversation">
                                            <treeselect
                                              v-bind:class="{'form-group--error': (submitted && !isInSessionOE && destination.destinationToUse === 'destination_conversation' 
                                              && !$v.groupList.$each[index].destinationList.$each[destinationIndex].conversation_id.required) }"
                                              :options="conversationList" placeholder="--Choose a Conversation--"
                                              @select="onDestinationchange(item, destinationIndex)" :multiple="false"
                                              v-model="destination.conversation_id" />
                                              <div class="refresh-conversation">
                                               <a href="#"><div title="Click to refresh the contents of the list" class="fa fa-refresh rotate" @click="getConversationAndJourneysAndKeywords()"></div></a>
                                             </div>
                                             </div>
                                          </div>
                                          <span
                                            v-if="(submitted && !isInSessionOE && destination.destinationToUse === 'destination_conversation' 
                                            && !$v.groupList.$each[index].destinationList.$each[destinationIndex].conversation_id.required)"
                                            class="text-red pull-right">Please choose a conversation.</span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                            </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="panel panel-default">
                  <div class="panel-heading">
                    <h3 class="panel-title">
                      Step 4 | Scheduling <span class="text-red">*</span>
                    </h3>
                  </div>
                  <div v-if="isInSessionOE">
                    <div class="panel-body" id="content-step-four">
                      <div class="row">
                        <div class="col-md-12 col-lg-12 col-xs-12">
                          <div style="display: flex; flex-direction: column;" class="col-xs-4 col-sm-4 col-md-4">
                            <div class="form-group">
                              <label class="radio-inline">
                                <input v-model="scheduleType" type="radio" value="daterange" name="scheduleType">Date
                                Range
                              </label>
                              <label class="radio-inline">
                                <input v-model="scheduleType" type="radio" value="activitycap"
                                  name="scheduleType">Activity
                                Cap
                              </label>
                              <label class="radio-inline">
                                <input v-model="scheduleType" type="radio" value="activityStatus"
                                  name="scheduleType">Always
                                On
                              </label>
                            </div>
                            <div class="row" style="padding: 0 15px; z-index: 10;" v-show="scheduleType=='daterange'">
                              <div class="row">
                                <div class="col-md-12 col-lg-6 col-xs-12">
                                  <div class="form-group" style="min-width: 150px;">
                                    <label class="required" for="date-from">Start Date</label>
                                    <input type="date" :max="formDataObj.end_date" v-model="formDataObj.start_date"
                                      id="date-from"
                                      v-bind:class="{'form-group--error': submitted && !$v.formDataObj.start_date.required && !formDataObj.start_date}"
                                      class="form-control " placeholder="Select Start Date" />
                                    <span
                                      v-if="submitted && !$v.formDataObj.start_date.required && !formDataObj.start_date"
                                      class="text-red pull-left">Please enter start date.</span>
                                  </div>
                                </div>
                                <div class="col-md-12 col-lg-6 col-xs-12">
                                  <div class="form-group" style="min-width: 150px; ">
                                    <label class="required" for="date-to">End Date</label>
                                    <input type="date" :min="formDataObj.start_date" v-model="formDataObj.end_date"
                                      v-bind:class="{'form-group--error': submitted && !$v.formDataObj.end_date.required && !formDataObj.end_date}"
                                      id="date-to" class="form-control " placeholder="Select End Date" />
                                    <span v-if="submitted && !$v.formDataObj.end_date.required && !formDataObj.end_date"
                                      class="text-red pull-left">Please enter end date.</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="col-xs-6 col-sm-6 col-md-6">
                              <span v-if="submitted && dateRangeRequired" class="text-red pull-right">Please select
                                date range.</span>
                            </div>
                            <div class="form-group" v-show="scheduleType=='activitycap'">
                              <div class="row">
                                <div class="form-group col-xs-12 col-sm-12 col-md-12">
                                  <treeselect v-model="activityCapChoice"
                                  :multiple=false
                                  :clearable=false
                                  :options="inSessionThresholdOptions                               "
                                  v-bind:class="{'form-group--error': submitted && activityCapChoiceRequired }"
                                  placeholder="--Choose a Threshold---"/>

                                  <span v-if="submitted && activityCapChoiceRequired" class="text-red pull-right">Please
                                    choose a limit.</span>
                                </div>
                              </div>
                              <div class="row">
                                <div class="form-group col-xs-12 col-sm-12 col-md-12">
                                  <input type="text" autocomplete="off"
                                    v-bind:class="{'form-group--error': (submitted && (!$v.formDataObj.threshold_limit.required || !$v.formDataObj.threshold_limit.minValue || !$v.formDataObj.threshold_limit.numeric)) }"
                                    v-model="formDataObj.threshold_limit" class="form-control" id="threshold_limit"
                                    placeholder="Enter Number" />
                                    <span v-if="submitted && !formDataObj.threshold_limit && !$v.formDataObj.threshold_limit.required" class="text-red pull-right">Please enter number.</span>
                                    <span v-if="submitted && (!$v.formDataObj.threshold_limit.minValue || !$v.formDataObj.threshold_limit.numeric)" class="text-red pull-left">Please enter valid integer value.</span>
                                </div>
                              </div>
                            </div>
                            <div class="form-group" v-show="scheduleType=='activityStatus'">
                              <div class="row">
                                <div class="form-inline form-group margin-left-20px">
                                  <label>Pause</label>
                                  <label class="switch">
                                    <input type="checkbox" v-model="toggleactivityStatus"
                                      @change="handleActivityToggle">
                                    <span class="slider round"></span>
                                  </label>
                                  <label>Active</label>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-xs-4 col-sm-4 col-md-4">
                            <div class="form-group col-md-12 col-lg-12 col-xs-12">
                              <label for="recurrence">Recurrence <span class="text-red">*</span>
                                <label class="hint-text">(Can the user see this once or many times?)</label>
                              </label>
                              <div class="row form-control" style="border: none;">
                                <label v-for="recurrence in recurrenceOptions" :key="recurrence.value"
                                  class="radio-inline ">
                                  <input type="radio" :disabled="scheduleType=='activitycap'"
                                    v-model="formDataObj.recurrence" :value="recurrence.value" />{{recurrence.label}}
                                </label>
                              </div>
                            </div>
                          </div>
                          <div class="col-xs-4 col-sm-4 col-md-4">
                            <div class="form-inline form-group">
                              <label>Inactivity timing <span class="text-red">*</span>
                                <label class="hint-text">(Cannot be greater than 23 hours. Sent within a 30 minute
                                  window from the selected time.)</label>
                              </label>
                              <div>
                                <input type="text" min="0" max="23" v-model="sendTime.hours" class="form-control"
                                  style="width:50px; text-align: right;" placeholder="HH"
                                  v-on:keyup="validateInactivityTime($event)" />
                                hrs :
                                <input type="text" min="0" max="59" v-model="sendTime.minutes" class="form-control"
                                  style="width:50px; text-align: right;" placeholder="MM"
                                  v-on:keyup="validateInactivityTime($event)" />
                                mins
                              </div>
                              <span v-if="submitted && isInvalidSendTime" class="text-red ">Please enter valid timing</span>
                              <span v-if="submitted && !sendTime.hours && !sendTime.minutes" class="text-red ">Please
                                enter inactivity timing</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-else>
                    <div class="panel-body" id="content-step-four">
                      <div class="row">
                        <div class="col-md-12 col-lg-12 col-xs-12">
                          <div class="col-lg-4 col-xs-4 col-sm-4 col-md-4">
                            <div class="form-group col-md-12 col-lg-12 col-xs-12">
                              <label for="recurrence">Recurrence <span class="text-red">*</span>
                                <label class="hint-text">(Can the user see this once or many times?)</label>
                              </label>
                              <div class="row form-control" style="border: none;">
                                <label v-for="recurrence in recurrenceOptions" :key="recurrence.value"
                                  class="radio-inline ">
                                  <input type="radio" @change="onRecurrenceOptionChange"
                                    v-model="formDataObj.recurrence" :value="recurrence.value" />{{recurrence.label}}
                                </label>
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-3 col-xs-3 col-sm-3 col-md-3">
                            <div class="form-group col-md-12 col-lg-12 col-xs-12">
                              <label for="schedule period">Schedule Period</label>
                              <div class="row form-control" style="border: none;">
                                <label class="radio-inline"  v-bind:class="{'reengagement-group-disabled': !scheduleType }">
                                  <input v-model="scheduleType" :disabled="formDataObj.recurrence==='ONETIME'" type="radio" value="daterange" name="scheduleType">Date Range
                                </label>
                                <label class="radio-inline"  v-bind:class="{'reengagement-group-disabled': !scheduleType }">
                                  <input v-model="scheduleType" :disabled="formDataObj.recurrence==='ONETIME'" type="radio" value="activityStatus" name="scheduleType">Always On
                                </label>
                              </div>
                            </div>
                          </div>   
                          <div class="col-lg-5 col-xs-5 col-sm-5 col-md-5">
                            <div v-if="formDataObj.recurrence==='ONETIME'" class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
                              <label class="required" for="date-from">Deployment Date &amp; Time</label>
                              <input type="datetime-local" v-model="formDataObj.start_date"
                                id="date-from"
                                v-bind:class="{'form-group--error': submitted && !$v.formDataObj.start_date.required && !formDataObj.start_date}"
                                class="form-control " placeholder="Select Deployment Date" />
                              <span
                                v-if="submitted && !$v.formDataObj.start_date.required && !formDataObj.start_date"
                                class="text-red pull-left">Please enter deployment date.</span>
                            </div>
                            <div v-else>
                              <div v-show="scheduleType=='daterange'" class="col-xs-12 col-sm-12 col-md-12 col-lg-12" style="display: flex">
                                <div  style="width: 50%">
                                  <label class="required" for="date-from">Start Date &amp; Time</label>
                                  <input type="datetime-local" :max="formDataObj.end_date" v-model="formDataObj.start_date"
                                    id="date-from"
                                    v-bind:class="{'form-group--error': submitted && !$v.formDataObj.start_date.required && !formDataObj.start_date}"
                                    class="form-control " placeholder="Select Start Date" />
                                  <span
                                    v-if="submitted && !$v.formDataObj.start_date.required && !formDataObj.start_date"
                                    class="text-red pull-left">Please enter start date.</span>
                                </div>
                                <div  style="width: 50%; margin-left: 10px;">
                                  <label class="required" for="date-to">End Date &amp; Time</label>
                                  <input type="datetime-local" :min="formDataObj.start_date" v-model="formDataObj.end_date"
                                    v-bind:class="{'form-group--error': submitted && !$v.formDataObj.end_date.required && !formDataObj.end_date}"
                                    id="date-to" class="form-control " placeholder="Select End Date" />
                                  <span v-if="submitted && !$v.formDataObj.end_date.required && !formDataObj.end_date"
                                    class="text-red pull-left">Please enter end date.</span>
                                </div>
                              </div>
                              <div class="col-xs-5 col-sm-5 col-md-5" v-show="scheduleType=='daterange'">
                                <span v-if="submitted && dateRangeRequired" class="text-red pull-right">Please select
                                  date range.</span>
                              </div>
                              <div v-show="scheduleType=='activityStatus'" class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                <label for="activity-status">Status</label>
                              </div>
                              <div v-show="scheduleType=='activityStatus'"  class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                  <div class="form-inline form-group">
                                    <label>Pause</label>
                                    <label class="switch">
                                      <input type="checkbox" v-model="toggleactivityStatus"
                                        @change="handleActivityToggle">
                                      <span class="slider round"></span>
                                    </label>
                                    <label>Active</label>
                                  </div>
                              </div>
                            </div>
                          </div>                         
                        </div>
                      </div>

                      <div class="row">
                      <div class="col-md-6 col-lg-6 col-xs-6">
                        <div class="col-md-12 col-lg-12 col-xs-12" style="margin:10px 0px">
                          <div class="col-lg-6 col-xs-6 col-sm-6 col-md-6" style="z-index: 10;" v-if="formDataObj.recurrence!=='ONETIME'">
                            <div class="form-inline form-group">
                              <label>Inactivity timing <span class="text-red">*</span>
                              </label>
                              <div>
                                <input type="text" v-model="delay.quantity" class="form-control"
                                    style="width:60px; text-align: right;" placeholder="Delay"
                                    v-on:keyup="validateInactivityTime($event)"/>
                                &nbsp;
                                <nv-select id="input-type" v-model="delay.units" class="form-control" style="width:90px"
                                    v-on:change="validateInactivityTime($event)">
                                    <option value="hrs">hrs</option>                                      
                                    <option value="days">days</option>
                                </nv-select>
                                &nbsp;
                                <i class="fa fa-times-circle fa-lg" v-on:click="resetDelay()" aria-hidden="true"></i>
                                &nbsp; &nbsp;
                              </div>
                              <span v-if="submitted && isInvalidDelay" class="text-red ">Inactivity timing should be minimum 24 hrs or 1 day</span>
                              <span v-if="submitted && !delay.units && !delay.quantity" class="text-red ">Please
                                enter inactivity timing</span>
                            </div>
                          </div>
                          <div class="col-lg-6 col-xs-6 col-sm-6 col-md-6" style="padding: 0px">
                            <div class="col-md-12 col-lg-12 col-xs-12">
                              <label for="last_rem_days">Days from last REM<span class="text-red">*</span></label>
                              <div>
                                <input type="text" autocomplete="off" v-bind:class="{'form-group--error': (submitted && (!$v.formDataObj.last_reengage_days.numeric || !$v.formDataObj.last_reengage_days.minValue)) }"
                                  placeholder="Enter Number" class="form-control" v-model="formDataObj.last_reengage_days" style="width: 50%;"/>
                                <span v-if="submitted && !$v.formDataObj.last_reengage_days.required" class="text-red pull-center">Please enter number.</span>
                                <span v-if="submitted && (!$v.formDataObj.last_reengage_days.numeric || !$v.formDataObj.last_reengage_days.minValue)" class="text-red pull-center">Please enter value greater than or equal to zero</span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-12 col-lg-12 col-xs-12" v-if="formDataObj.recurrence!=='ONETIME'">
                          <div class="col-lg-12 col-xs-12 col-sm-12 col-md-12"  >
                            <label class="checkbox-inline">
                              <input type="checkbox" v-model="formDataObj.skip_upperbound" />
                                <b><label class="hint-text">(Engineers Only)</label> Remove upperbound for inactivity timing</b>
                            </label>
                          </div>
                        </div>

                      <div class="col-md-12 col-lg-12 col-xs-12">
                        <div class="col-lg-12 col-xs-12 col-sm-12 col-md-12" style="padding: 0px 15px; margin-top:15px; z-index: 10;">
                          <div class="panel panel-default">
                            <div class="panel-heading  campaign-goals-header">
                              <h3 class="panel-title" style="width: calc( 100% - 50px);">
                                  Campaign Thresholds (Optional)
                                  <label class="hint-text">(Set the limit to this campaign)</label>
                              </h3>
                              <label class="switch">
                                <input type="checkbox" v-model="isCampaignThresholdOn" @change="onThresholdSwitchChange">
                                <span class="slider round"></span>
                              </label>
                            </div>
                            <div class="panel-body">
                              <div class="goals-container">
                                <div style="flex: 0.5">
                                  <treeselect v-model="selectedThreshold"
                                    :multiple=false
                                    :clearable=false
                                    :options="ooSsessionThresholdOptions.filter(item => item.recurrence_type === 'BOTH' || item.recurrence_type === formDataObj.recurrence)"
                                    v-bind:class="{'form-group--error': submitted && !isInSessionOE && isCampaignThresholdOn && activityCapChoiceRequired}"
                                    :disabled="!isCampaignThresholdOn"
                                    placeholder="--Choose a Threshold---"/>
                                  <span v-if="submitted && isCampaignThresholdOn && !isInSessionOE && activityCapChoiceRequired" class="text-red pull-right">Please choose a threshold</span>
                                </div>
                                  <div style="margin-left: 10px; flex: 0.5">
                                    <input  class="form-control" type="text" autocomplete="off"
                                      v-bind:class="{'form-group--error': (submitted && !isInSessionOE && (!$v.formDataObj.threshold_limit.required || !$v.formDataObj.threshold_limit.minValue || !$v.formDataObj.threshold_limit.numeric)) }"
                                      v-model="formDataObj.threshold_limit"
                                      placeholder="Enter Number" :disabled="!isCampaignThresholdOn"/>
                                    <span v-if="submitted && !isInSessionOE && !$v.formDataObj.threshold_limit.required" class="text-red pull-right">Please enter number.</span>
                                    <span v-if="submitted && !isInSessionOE && (!$v.formDataObj.threshold_limit.minValue || !$v.formDataObj.threshold_limit.numeric)" class="text-red pull-left">Please enter valid integer value.</span>
                                  </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="col-md-12 col-lg-12 col-xs-12" style="margin:10px 0px" v-if="formDataObj.recurrence!=='ONETIME'">
                        <div class="col-md-12 col-lg-12 col-xs-12">
                          <label for="max_templated_message">Max templated messages(nudges) per user<span class="text-red">*</span>
                            <label class="hint-text" style="margin: 0px;">(Valid for this campaign only)</label>
                          </label>
                          <div>
                            <nv-select id="input-type" v-model="formDataObj.max_nudge_per_user" class="form-control" style="width: 25%;"
                                v-on:change="validateInactivityTime($event)">
                                <option v-for="item in 10" :key="item" :value="item">{{item}}</option>
                            </nv-select>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-12 col-lg-12 col-xs-12">
                        <div v-if="formDataObj.recurrence!=='ONETIME'" class="col-lg-12 col-xs-12 col-sm-12 col-md-12" style="padding: 0px 15px; margin-top:15px; z-index: 10;">
                          <div class="panel panel-default">
                            <div class="panel-heading  campaign-goals-header">
                              <h3 class="panel-title" style="width: calc( 100% - 50px);">
                                  Schedule on specific date (Optional)
                              </h3>
                              <label class="switch">
                                <input type="checkbox" v-model="isScheduleDateOn" @change="onScheduleSwitchChange">
                                <span class="slider round"></span>
                              </label>
                            </div>
                            <div class="panel-body">
                              <div style = "margin-left: 10px; margin-bottom: 20px;">
                                <button :disabled="!isScheduleDateOn" type="button" class="btn btn-primary btn-rounded" @click="addSchedule"><i class="fa fa-plus" aria-hidden="true"></i></button> Add new schedule 
                              </div>
                              <div v-for="(item, index) in schedules" :key="index" class="dayAndTime">
                                <div class="form-group col-xs-5 col-lg-5 col-sm-5 col-md-5">
                                  <label >Select Day</label>
                                  <nv-select :disabled="!isScheduleDateOn" class="form-control required"
                                    v-bind:class="{'form-group--error': submitted && isScheduleDateOn && !$v.schedules.$each[index].selectedDay.required }"
                                    id="audience-type-builder" v-model="item.selectedDay">
                                    <option value="">--Choose a Day--</option>
                                    <option v-for="(data, index) in daysOfWeek" :key="index" :value="data">
                                      {{data}}</option>
                                  </nv-select>
                                  <span v-if="submitted && isScheduleDateOn && !$v.schedules.$each[index].selectedDay.required"
                                    class="text-red pull-right">Please choose a day.
                                  </span>
                                </div>
                                <div class="form-group col-xs-5 col-lg-5 col-sm-5 col-md-5">
                                  <label >Select Time</label>
                                  <input :disabled="!isScheduleDateOn" type="time" class="form-control" v-bind:class="{'form-group--error': submitted && isScheduleDateOn && !$v.schedules.$each[index].selectedTime.required }" v-model="item.selectedTime" />
                                  <span v-if="submitted && isScheduleDateOn && !$v.schedules.$each[index].selectedTime.required"
                                    class="text-red pull-right">Please choose a time.
                                  </span>
                                </div>
                                <div class="col-xs-2 col-lg-2 col-sm-2 col-md-2">
                                  <button :disabled="!isScheduleDateOn" type="button" @click="removeSchedule(index)" class="btn btn-rounded btn-remove-nudge btn-nudge btn-danger col-xs-2 col-sm-2 col-md-2 col-2" style="margin-top: 20px;">
                                    <i class="fa fa-minus" aria-hidden="true"></i>
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                         </div>
                        </div>
                       </div>
                      </div> 
                    </div>
                  </div>
                </div>
              </form>
              <div class="row oe-action-buttons">
                <div class="action-button">
                  <input type="button" v-show="checkButtonVisibility('draft')"
                    class="btn btn-primary margin-left-20px" v-on:click="saveOpportunity('saveasdraft')"
                    :value="formDataObj.opportunity_status === 0 ? 'SAVE': 'SAVE AS DRAFT'" />
                  <input type="button" v-show="checkButtonVisibility('deploy')"
                    class="btn btn-primary margin-left-20px" v-on:click="saveOpportunity('saveanddeploy')"
                    :value="formDataObj.opportunity_status === 0 ? 'SAVE &amp; DEPLOY' : 'SAVE'" />
                  <input type="button" class="btn btn-primary margin-left-20px" v-on:click="resetForm()"
                    value="CANCEL" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-backdrop" v-if="showNewFeaturePrompt">
        <div class="modal new-feature" role="dialog" aria-labelledby="modalTitle" aria-describedby="modalDescription" style="height: 415px; width: 518px;">
          <header class="modal-header">
            <div class="header-style">
              <h3>New Features !</h3>
              <i v-on:click="closeNewFeatureModal" class="fa fa-close" style="font-size:22px;color:red" title="Close"></i>
            </div>
          </header>
          <section class="modal-body">
            <div class="style-section">
              <h4 class="style-button-section"><b>Button</b></h4>
              <div>We can now add buttons for message instead of asking the user to type the numbers.</div>
              <div class="style-template-text"><b>Template to use button:- </b></div>
              <div class="style-select-options">Please select one of the following options :- </div> 
              <span>{{ showTextInfoForButton }}</span>
              <h4 class="style-list-section"><b>List</b></h4>
              <div>We can support lists instead of buttons whenever the user has more than 3 options to be selected.</div>
              <div class="style-template-text"><b>Template to use list:- </b></div>
              <div class="style-select-options">Please select one of the following options :- </div> 
              <span>{{ showTextInfoForList }}</span>

              <h4 class="style-list-section"><b>User Name</b></h4>
              <div>We can support adding user's name dynamically.</div>
              <div class="style-template-text"><b>Template to use user name:-(Currently, supported only for Ninety JoR) </b></div>
              <div class="style-select-options">Hi {{ showTextInfoForUserName }}, hope you're doing fine </div> 

              <h4 class="style-list-section"><b>Provider Code</b></h4>
              <div>We can support adding provider's code dynamically.</div>
              <div class="style-template-text"><b>Template to use provider code:-</b></div>
              <div class="style-select-options">Hi {{ showTextInfoForUserName }}, time to fill up weekly referral report. Click at like http://ref.nivi.io/{{ showTextInfoForProviderCode }} }} </div> 
            </div>
          </section>
        </div>
      </div>
    </section>

    <div class="modal-backdrop" v-if="showNudgePreview">
      <div class="modal modal-md" style="max-width:800px; height: max-content">
          <div style="margin: 20px; max-height: 400px; overflow-y: auto;">
            <slot name="body">
              <div class="margin-bottom-10px">
                <template v-if="showCountryPicker">
                  <label class="required">Country</label>
                  <nv-select class="form-control" style="display:inline-block; min-width:180px; vertical-align:middle; margin-left:8px" v-model="turnCountry" v-on:change="onTurnCountryChange()">
                    <option value="">-- Select Country --</option>
                    <option v-for="country in turnCountryList" :key="country" :value="country">{{country}}</option>
                  </nv-select>
                  <div style="margin-top:8px">Templates differ per country's Turn namespace. Select a country to load them.</div>
                </template>
                <template v-else>
                  <span>Templates from <b>{{turnCountry}}</b></span>
                  <button v-if="turnCountryList.length > 1" type="button" class="btn btn-link" v-on:click="showCountryPicker = true">Change Country</button>
                </template>
              </div>
              <div v-if="turnCountry">
              <div class="nudge-origin-title">WhatsApp Nudge(s):</div>
              <div class="margin-bottom-10px" v-for="(data, index) in nudgePreviewData" :key="'nudge' + index">
                <span class="nudge-language">{{data.language}} :</span>
                <!-- A media header: the file set on the template, for this campaign's country. -->
                <div v-if="data.turn_template_data && ['IMAGE', 'VIDEO', 'DOCUMENT'].includes(data.turn_template_data.HEADER_FORMAT)" style="max-width: 260px">
                  <media-preview
                    :format="data.turn_template_data.HEADER_FORMAT"
                    :media-id="data.media_id"
                    :media-name="data.media_name || ''"
                    :country-id="formDataObj.country_id || null"
                    :language-id="data.language_id"
                  />
                </div>
                <div v-if="data.turn_template_data && data.turn_template_data.HEADER" class="nudge-whatsapp-header">
                  <span v-for="(part, index) in data.headerObj.text" :key="'header' + index">
                    {{ part }}<input v-model="data.headerObj.gaps[index]" placeholder="Enter text for header" v-on:keyup="trimMoreThan4Spaces" v-on:blur="trimMoreThan4Spaces" style="width: 500px;">
                  </span>
                  <span>{{ data.headerObj.last }}</span>
                </div>
                <div v-if="data.turn_template_data && data.turn_template_data.BODY" class="nudge-whatsapp-body">
                  <span v-for="(part, index) in data.bodyObj.text" :key="'body' + index" style="white-space: pre-line">{{ part }}<input v-model="data.bodyObj.gaps[index]" v-on:keyup="trimMoreThan4Spaces" v-on:blur="trimMoreThan4Spaces" placeholder="Enter text for body" style="margin-bottom:4px; width: 500px;"></span><span>{{ data.bodyObj.last }}</span>
                </div>
                <div v-if="data.turn_template_data && data.turn_template_data.FOOTER" class="nudge-whatsapp-footer">{{data.turn_template_data.FOOTER}}</div>
                <div v-if="data.turn_template_data && data.turn_template_data.BUTTONS" style="margin-top: 5px">
                  <div v-for="(button, bIndex) in data.buttonsObj" :key="'button' + bIndex" class="nudge-whatsapp-button">
                    <template v-if="button.text.length">
                      <span v-for="(part, index) in button.text" :key="'buttonPart' + index">
                        {{ part }}<input v-model="button.gaps[index]" placeholder="Enter value for button link" v-on:keyup="trimMoreThan4Spaces" v-on:blur="trimMoreThan4Spaces" style="width: 300px;">
                      </span>
                      <span>{{ button.last }}</span>
                    </template>
                    <template v-else>{{ button.label }}</template>
                  </div>
                </div>
                <div v-if="!data.turn_template_data" class="nudge-whatsapp-body"> -- Not available in {{turnCountry}} -- </div>
              </div>

              <div class="nudge-origin-title" style="margin-top: 15px">Facebook Nudge(s):</div>
              <div class="margin-bottom-10px" v-for="(data, index) in nudgePreviewData" :key="index">
                <span class="nudge-language">{{data.language}} :</span>
                <div v-if="data.fb_nudge_text" class="nudge-whatsapp-body">{{data.fb_nudge_text}}</div>
                <div v-else class="nudge-whatsapp-body"> -- No data available -- </div>
              </div>
              </div>
            </slot>
          </div>

          <div class="modal-footer" style="margin-top: auto; padding: 0px">
            <div class="form-group pull-right" style="margin-top: 10px">
              <div class="col-sm-12">
                <button v-if="turnCountry && isDynamicTemplate(groupList[previewGroupIndex].msg_template_id)" type="button" class="btn btn-primary" @click="saveConfiguredNudgeData">Save</button>
                <button type="button" class="btn btn-primary" @click="closeNudgePreview">Close</button> 
              </div>
            </div>
          </div>
      </div>
    </div>
    <BlockUI v-if="loading"><i class="fa fa-cog fa-spin fa-3x fa-fw"></i><br />Please wait...</BlockUI>
  </div>
</template>

<script>
import { required, requiredIf, minValue, maxValue, numeric } from 'vuelidate/lib/validators'
import moment from 'moment'
import capitalize from 'lodash/capitalize'
import orderBy from 'lodash/orderBy'
import api from '../../../utils/api'
import MediaPreview from '../common/MediaPreview.vue'
import { domain, instanceCountriesMapping } from '../../../config/constants'
import { RECURRENCE_TYPE, recurrenceOptions, splitOptions, opportunityTypeOptions,
maxOpportunityGroupsAllowed, OPPORTUNITY_TYPES, daysOfWeek } from './constants'
import { formatDate, isButtonTextGreaterThan20Chars } from '../../../utils/utilities'

export default {
  name: 'modal',
  components: { MediaPreview },
  validations: {
    formDataObj: {
      opportunity_name: { required },
      customer_id: { required },
      country_id: { required },
      threshold_limit: { required: requiredIf(function () {
        if (this.isInSessionOE) {
          return this.activityCapChoiceRequired
        } else return this.isCampaignThresholdOn
      }),
        minValue: minValue(1),
        numeric
      },
      destination_conversation: { required: requiredIf(function () {
        return this.selectedThreshold && this.ooSsessionThresholdOptions.find(threshold => (threshold.id === this.selectedThreshold && threshold.args.includes('destination_conversation')))
      })},
      audience_id: { required: requiredIf(function () {
        return !this.formDataObj.conversation_id
      })},
      conversation_id: { required: requiredIf(function () {
        return !this.formDataObj.audience_id
      })},
      start_date: { required: requiredIf(function (prop) {
        return this.scheduleType === 'daterange' || (prop.recurrence === RECURRENCE_TYPE.ONE_TIME && !this.isInSessionOE)
      })},
      end_date: { required: requiredIf(function (prop) {
        return this.scheduleType === 'daterange' && prop.recurrence === RECURRENCE_TYPE.RECURRING
      })},
      last_reengage_days: { required: requiredIf(function () {
        return !this.isInSessionOE
      }),
        minValue: minValue(0),
        numeric
      }
    },
    schedules: {
      $each: {
        selectedDay: { required: requiredIf(function () {
          return !this.isInSessionOE && this.formDataObj.recurrence !== 'ONETIME' && this.isScheduleDateOn
        })},
        selectedTime: { required: requiredIf(function () {
          return !this.isInSessionOE && this.formDataObj.recurrence !== 'ONETIME' && this.isScheduleDateOn
        })}
      }
    },
    groupList: {
      $each: {
        msg_template_id: { required: requiredIf(function () {
          return !this.isDraft && !this.isInSessionOE
        })},
        split_percent: { required: requiredIf(function () {
          return !this.isDraft
        }),
          minValue: minValue(0),
          maxValue: maxValue(100),
          numeric
        },
        destinationList: {
          $each: {
            website_link: { required: requiredIf(function (prop) {
              return !this.isDraft && this.isInSessionOE && !prop.keyword_id && !prop.conversation_id
            })},
            keyword_id: { required: requiredIf(function (prop) {
              if (this.isInSessionOE) {
                return !this.isDraft && !prop.website_link && !prop.conversation_id
              } else {
                return !this.isDraft && !prop.conversation_id
              }
            })},
            conversation_id: { required: requiredIf(function (prop) {
              if (this.isInSessionOE) {
                return !this.isDraft && !prop.website_link && !prop.keyword_id
              } else {
                return !this.isDraft && !prop.keyword_id
              }
            })}
          }
        }
      }
    }
  },
  data () {
    return {
      currentGroupListDynamicValue: null,
      groupList: [{
        selectedCountry: '',
        messageLanguage: '',
        messageText: '',
        split_percent: null,
        destinationList: [{
          website_link: '',
          conversation_id: null,
          keyword_id: null,
          destinationToUse: 'keyword'
        }],
        msg_template_id: null,
        is_intermediate_message: false,
        message: []
      }],
      selectedThreshold: null,
      splitOptions: splitOptions,
      opportunityTypeOptions: opportunityTypeOptions,
      split_type: 'EQUAL',
      opportunityType: OPPORTUNITY_TYPES.IN_SESSION,
      isInSessionOE: true,
      formatDate: formatDate,
      selectedAudienceType: '',
      loading: false,
      clientList: [],
      filteredClientList: [],
      audienceList: [],
      filteredAudienceList: [],
      languages: [],
      allApps: [],
      supportedCountries: [],
      supportedLanguages: [],
      filteredKeywords: [],
      urlList: [],
      messageContent: {},
      textMessage: {},
      countryAndLanguages: {},
      clientCountries: {},
      journeyList: [],
      nudgesList: [],
      conversationList: [],
      selectedLanguage: '',
      showKeywordAutoCompList: false,
      showDestinationConversationAutoCompList: false,
      scheduleType: 'daterange',
      activityCapChoice: null,
      opportunityAction: '',
      toggleactivityStatus: true,
      timezone: '',
      formDataObj: {
        id: null,
        opportunity_name: '',
        customer_id: '',
        audience_id: '',
        conversation_id: '',
        destination_conversation: null,
        activity_status: 'ACTIVE',
        threshold_limit: null,
        link_id: '',
        start_date: '',
        end_date: '',
        is_draft: true,
        recurrence: RECURRENCE_TYPE.ONE_TIME,
        opportunity_status: 0,
        country_id: '',
        is_in_session: false,
        last_reengage_days: 7,
        max_nudge_per_user: 1,
        isNewUserBatch: false,
        skip_upperbound: false
      },
      delay: {
        quantity: '',
        units: 'hrs'
      },
      sendTime: {
        hours: '',
        minutes: ''
      },
      isInvalidSendTime: true,
      isInvalidDelay: true,
      isEmptySendTime: true,
      submitted: false,
      messageFormSubmitted: false,
      dateRangeRequired: false,
      maxOffersRequired: false,
      isFormValid: true,
      activityCapChoiceRequired: false,
      countryRequired: false,
      messageExists: false,
      actionToBePerformed: 'Create Opportunity',
      domain: domain,
      clickUrlDomain: '',
      recurrenceOptions: recurrenceOptions,
      ooSsessionThresholdOptions: [],
      inSessionThresholdOptions: [],
      keywordsList: [],
      isCampaignThresholdOn: false,
      destination_conversation: '',
      showNudgePreview: false,
      nudgePreviewData: [],
      turnCountry: '',
      turnCountryList: [],
      showCountryPicker: false,
      pendingNudgePreview: null,
      daysOfWeek,
      isScheduleDateOn: false,
      schedules: [{
        selectedDay: '',
        selectedTime: ''
      }],
      showNewFeaturePrompt: false,
      showTextInfoForButton: '{{item1}} {{item2}} {{item3}}',
      showTextInfoForList: '{{item1}} {{item2}} {{item3}} {{item4}} [[ListButtonText]]',
      showTextInfoForUserName: '{{USER_NAME}}',
      showTextInfoForProviderCode: '{{PROVIDER_CODE}}'
    }
  },
  methods: {
    addSchedule () {
      this.schedules.push({
        selectedDay: '',
        selectedTime: ''
      })
    },
    removeSchedule (index) {
      this.schedules.splice(index, 1)
    },
    checkDestinationOptions (event, destinationArr) {
      if (!event && destinationArr.length > 1) {
        destinationArr.splice(1)
      }
      return destinationArr
    },
    addGroup () {
      if (this.groupList.length === maxOpportunityGroupsAllowed) {
        this.$swal({
          type: 'error',
          text: `Maximum only ${maxOpportunityGroupsAllowed} groups can be created`
        })
        return
      }

      let message = []
      this.languages.forEach(lang => {
        message.push({
          message: '',
          country_id: lang.country_id,
          lang_id: lang.lang_id,
          language: lang.alias,
          name: lang.language,
          country: lang.country
        })
      })

      this.groupList.push({
        selectedCountry: '',
        messageLanguage: '',
        messageText: '',
        destinationList: [{
          website_link: '',
          conversation_id: null,
          keyword_id: null,
          destinationToUse: 'keyword'
        }],
        split_percent: null,
        message: message,
        msg_template_id: null,
        is_intermediate_message: false
      })
      this.setNewSplitData()
    },
    addDestination (index) {
      this.groupList[index].destinationList.push({
        website_link: '',
        conversation_id: null,
        keyword_id: null,
        destinationToUse: 'keyword'
      })
    },
    removeDestination (index, destinationIndex) {
      this.groupList[index].destinationList.splice(destinationIndex, 1)
    },
    removeGroup (index) {
      this.groupList.splice(index, 1)
      this.setNewSplitData()
    },
    onSplitTypeChange (_val) {
      this.setNewSplitData()
    },
    setNewSplitData () {
      if (this.split_type === 'EQUAL' && this.groupList.length) {
        const num = 100
        const parts = this.groupList.length
        let counter = 0
        let split = Math.floor(num / parts)
        let rem = num % parts
        if (rem !== 0) counter = rem
        this.groupList.forEach((element, _index) => {
          let per = split
          if (counter > 0) per = per + 1
          element.split_percent = per
          counter = counter - 1
        })
      }
    },
    onOpportunityTypeChange (event) {
      this.isInSessionOE = (event.target.value === OPPORTUNITY_TYPES.IN_SESSION)
      this.filteredAudienceList = [...this.audienceList.filter(audience => audience.country_id === this.formDataObj.country_id)]
      this.formDataObj.audience_id = ''
      this.formDataObj.conversation_id = ''
      if (this.scheduleType === 'activitycap' && event.target.value === OPPORTUNITY_TYPES.OUT_OF_SESSION) {
        this.scheduleType = 'daterange'
        this.formDataObj.threshold_limit = null
      }
      if (this.isInSessionOE) this.isInvalidSendTime = true
      else this.isInvalidDelay = true
    },
    onRecurrenceOptionChange (event) {
      if (event.target.value === RECURRENCE_TYPE.ONE_TIME) {
        this.scheduleType = ''
      } else {
        this.formDataObj.max_nudge_per_user = 1
        this.scheduleType = 'daterange'
      }
      this.selectedThreshold = null
      this.formDataObj.threshold_limit = null
      this.formDataObj.start_date = ''
    },
    handleActivityToggle () {
      if (this.toggleactivityStatus) {
        this.formDataObj.activity_status = 'ACTIVE'
      } else {
        this.formDataObj.activity_status = 'PAUSE'
      }
    },
    checkButtonVisibility (action) {
      const status = this.formDataObj.opportunity_status
      return action === 'draft' ? status === 0 || status === 1 || status === 2 : status === 0 || status === 1
    },
    resetForm () {
      this.formDataObj = {}
      this.scheduleType = 'daterange'
      this.$router.push({ name: 'opportunity-list' })
    },
    saveOpportunity (action) {
      this.opportunityAction = action
      this.createOrUpdateOpportunity()
    },
    resetDelay () {
      this.isInvalidDelay = false
      this.delay = { quantity: '', units: 'hrs' }
    },
    validateInSessionInactivityTiming () {
      this.sendTime.hours = this.sendTime.hours.trim()
      this.sendTime.minutes = this.sendTime.minutes.trim()
      this.isInvalidSendTime = false

      if (this.sendTime.hours.length > 2) {
        this.isInvalidSendTime = true
        return true
      }
      if (this.sendTime.minutes.length > 2) {
        this.isInvalidSendTime = true
        return true
      }
      if (isNaN(this.sendTime.hours) || isNaN(this.sendTime.minutes)) {
        this.isInvalidSendTime = true
        return true
      } else if (this.sendTime.hours && !this.sendTime.minutes) {
        this.isInvalidSendTime = true
        return true
      } else if (!this.sendTime.hours && this.sendTime.minutes) {
        this.isInvalidSendTime = true
        return true
      } else if (Number(this.sendTime.hours) > 23 || Number(this.sendTime.minutes) > 59) {
        this.isInvalidSendTime = true
        return true
      } else if (Number(this.sendTime.hours) === 23 && Number(this.sendTime.minutes) > 0) {
        this.isInvalidSendTime = true
        return true
      }
      this.isInvalidDelay = false
      return false
    },
    validateOutOfSessionInactivityTiming () {
      this.delay.quantity = this.delay.quantity.trim()
      if (isNaN(this.delay.quantity.trim())) {
        this.delay.quantity = ''
      }
      this.isInvalidDelay = false
      if (!this.delay.quantity) {
        this.isInvalidDelay = true
        return true
      }
      if (!this.delay.units) {
        this.isInvalidDelay = true
        return true
      } else if (isNaN(this.delay.quantity)) {
        this.isInvalidDelay = true
        return true
      } else if (this.delay.units === 'hrs' && Number(this.delay.quantity) < 24) {
        this.isInvalidDelay = true
        return true
      } else if (this.delay.units === 'days' && Number(this.delay.quantity) < 1) {
        this.isInvalidDelay = true
        return true
      }
      this.isInvalidSendTime = false
      return false
    },
    validateInactivityTime (_event) {
      if (this.isInSessionOE) {
        return this.validateInSessionInactivityTiming() // this.sendTime and this.isInvalidSendTime vars are for in session. Will merge this in future with delay vars
      } else if (this.formDataObj.recurrence !== RECURRENCE_TYPE.ONE_TIME) {
        return this.validateOutOfSessionInactivityTiming() // this.delay and this.isInvalidDelay vars are for out of session
      }
    },
    removeLinkFromMessage (message) {
      let linkIndex = message.indexOf('https://')
      return linkIndex !== -1 ? message.slice(0, linkIndex) : message
    },
    extractLinkFromMessage (linkId) {
      const url = this.urlList.find(url => url.id === linkId)
      let linkIndex = this.clickUrlDomain.indexOf('https://')
      return linkIndex !== -1 ? this.clickUrlDomain.slice(linkIndex) + url.code : ''
    },
    updateAudienceType () {
      if (this.formDataObj.conversation_id) {
        this.selectedAudienceType = 'journey'
      } else if (this.formDataObj.audience_id) {
        this.selectedAudienceType = 'audience'
      }
    },
    onDestinationchange (item, destinationIndex) {
      if (item.destinationList[destinationIndex].destinationToUse === 'keyword') {
        item.destinationList[destinationIndex].conversation_id = null
        item.destinationList[destinationIndex].website_link = ''
      } else if (item.destinationList[destinationIndex].destinationToUse === 'website_link') {
        item.destinationList[destinationIndex].conversation_id = null
        item.destinationList[destinationIndex].keyword_id = null
      } else if (item.destinationList[destinationIndex].destinationToUse === 'destination_conversation') {
        item.destinationList[destinationIndex].keyword_id = null
        item.destinationList[destinationIndex].website_link = ''
      }
    },
    async getTimeZone (param) {
      try {
        const response = await api.buildRequest(`getTimezone`, 'POST', param)
        return response.data.payload
      } catch (error) {
        this.$swal({
          type: 'error',
          text: error.response ? error.response.data.payload.message : 'An error occurred'
        })
      }
    },
    async handleCountryChange () {
      if (this.formDataObj.country_id) {
        const country = Object.keys(this.clientCountries).find(k => this.clientCountries[k] === this.formDataObj.country_id)
        this.timezone = await this.getTimeZone({ country: country })
        this.filteredKeywords = [...this.keywordsList.filter(keyword => keyword.country_id === this.formDataObj.country_id)]
        this.filteredAudienceList = [...this.audienceList.filter(audience => audience.country_id === this.formDataObj.country_id)]
        this.filteredClientList = [...this.clientList.filter(client => (client.country_id === this.formDataObj.country_id || client.country_id === null) && client.is_deleted === false)].map(client => ({
          id: client.id,
          name: client.name
        }))
        this.getLanguagesInCountry(country)
        this.groupList.forEach(group => {
          group.message = []
          this.languages.forEach(lang => {
            group.message.push({
              message: '',
              country_id: lang.country_id,
              lang_id: lang.lang_id,
              language: lang.alias,
              name: lang.language,
              country: lang.country
            })
          })
        })
      } else {
        this.filteredKeywords = []
        this.filteredAudienceList = []
        this.filteredClientList = []
      }
    },
    async getSupportedCountriesLanguages () {
      return new Promise(resolve => {
        api.buildRequest('getSupportedCountriesLanguages', 'POST').then(({ data }) => {
          const countryLanguages = data.payload
          this.prepareCountryLanguages(countryLanguages)
          resolve()
        }).catch(({ response }) => {
          resolve(true)
          this.loading = false
          this.$swal({
            type: 'error',
            text: response ? response.data.payload.message : 'An error occurred'
          })
        })
      })
    },
    prepareCountryLanguages (countryLanguages) {
      const domainName = window.location.hostname
      const possibleCountries = instanceCountriesMapping[domainName].countries

      countryLanguages.forEach(sclData => {
        const slcObj = {
          lang_id: sclData.lang_id,
          country_id: sclData.country_id,
          language: sclData.language,
          name: sclData.language,
          alias: sclData.alias,
          country: sclData.country
        }
        if (!this.countryAndLanguages[`${sclData.country}`]) this.countryAndLanguages[`${sclData.country}`] = []
        this.countryAndLanguages[`${sclData.country}`].push(slcObj)
        if (sclData.country !== 'Global' && possibleCountries.includes(sclData.country.toLowerCase())) {
          if (!this.clientCountries[`${sclData.country}`]) {
            this.clientCountries[`${sclData.country}`] = sclData.country_id
          }
        }
      })
    },
    getLanguagesInCountry (selectedCountry) {
      if (!selectedCountry) {
        this.languages = []
      } else {
        this.languages = this.countryAndLanguages[selectedCountry]
      }
    },
    checkValidations (preStr, btnArray, optionArray, messageText) {
      if (btnArray || optionArray) {
        let messageAfterButtonOrListRemoved = messageText.trim().replace(/{{(.+?)}}|\[\[(.*?)\]\]/g, '')
        if (!messageAfterButtonOrListRemoved) {
          return {
            resp: false,
            error: {
              type: 'error',
              html: `<h4><b>${preStr}</b></h4>
              <h5>Please enter some plain text while using Buttons and Lists</h5>`
            }
          }
        }
      }
      if (Array.isArray(btnArray)) {
        for (const str of btnArray) {
          if (!str) {
            return {
              resp: false,
              error: {
                type: 'error',
                html: `<h4><b>${preStr}</b></h4>
                <h5>Please Add Button text</h5>`
              }
            }
          } else if (isButtonTextGreaterThan20Chars(str)) {
            return {
              resp: false,
              error: {
                type: 'error',
                html: `<h4><b>${preStr}</b></h4>
                <h5>Button text should be less than 20 characters</h5>`
              }
            }
          }
        }
      }
      if ((Array.isArray(btnArray) && btnArray.length <= 3) && (Array.isArray(optionArray) && optionArray.length)) {
        return {
          resp: false,
          error: {
            type: 'error',
            html: `<h4><b>${preStr}</b></h4>
            <h5>List options not needed for less then 3 buttons</h5>`
          }
        }
      }
      if ((Array.isArray(btnArray) && btnArray.length > 3 && !btnArray[0].includes('NINETY')) && (!optionArray || !optionArray.length)) {
        return {
          resp: false,
          error: {
            type: 'error',
            html: `<h4><b>${preStr}</b></h4>
            <h5>List options needed for more than 3 buttons.</h5>
            <h5>Please add list option like [[List Button Text]]</h5>`
          }
        }
      }
      if ((!btnArray || !btnArray.length) && (Array.isArray(optionArray) && optionArray.length)) {
        return {
          resp: false,
          error: {
            type: 'error',
            html: `<h4><b>${preStr}</b></h4>
            <h5>Add list option when more then 3 buttons</h5>`
          }
        }
      }
      if (Array.isArray(optionArray)) {
        for (let str of optionArray) {
          str = str.trim()
          if (!str) {
            return {
              resp: false,
              error: {
                type: 'error',
                html: `<h4><b>${preStr}</b></h4>
                <h5>Please Add list option text</h5>`
              }
            }
          } else if (isButtonTextGreaterThan20Chars(str)) {
            return {
              resp: false,
              error: {
                type: 'error',
                html: `<h4><b>${preStr}</b></h4>
                <h5>List option text should be less than 20 characters</h5>`
              }
            }
          }
        }
      }
      if (Array.isArray(optionArray) && optionArray.length > 1) {
        return {
          resp: false,
          error: {
            type: 'error',
            html: `<h4><b>${preStr}</b></h4>
            <h5>There should be only one list option</h5>`
          }
        }
      }
      if (Array.isArray(btnArray) && btnArray.length > 10) {
        return {
          resp: false,
          error: {
            type: 'error',
            html: `<h4><b>${preStr}</b></h4> 
            <h5>Maximum of 10 options allowed for buttons/lists.</h5>
            <h5>Please use plain text format if more than 10 options are needed.</h5>`
          }
        }
      }
      return {resp: true, error: null}
    },
    showInfoPopUp (event) {
      event.preventDefault()
      event.stopPropagation()
      this.showNewFeaturePrompt = true
    },
    closeNewFeatureModal () {
      this.showNewFeaturePrompt = false
    },
    validateConfigData () {
      let config = this.groupList
      for (let [index, item] of config.entries()) {
        for (let data of item.message) {
          let preStr = `Group ${index + 1} --> ${data.country} (${data.language})`
          let btnArray = data.message.match(/(?<=\{\{).*?(?=\}\})/g)
          let optionArray = data.message.match(/(?<=\[\[).*?(?=\]\])/g)
          let { resp, error } = this.checkValidations(preStr, btnArray, optionArray, data.message)
          if (!resp && error) {
            this.$swal(error)
            return false
          }
        }
      }
      return true
    },
    parseDate (time, format = 'y-m-d h:i:s') {
      if (!time && time !== 0) {
        return '0000-00-00 00:00:00'
      }
      const date = time instanceof Date ? time : new Date(parseInt(time, 10))
      const formatObj = {
        y: date.getFullYear(),
        m: date.getMonth() + 1,
        d: date.getDate(),
        h: date.getHours(),
        i: date.getMinutes(),
        s: date.getSeconds(),
        a: date.getDay()
      }
      return format.replace(/(y|m|d|h|i|s|a)+/gi, (match, p1) => {
        p1 = p1.toLowerCase()
        let value = formatObj[p1]

        if (match.length > 0 && value < 10) {
          value = `0${value}`
        }

        return value || (p1 === 'y' ? '0000' : '00')
      })
    },
    onThresholdSwitchChange (event, e) {
      if (!this.isCampaignThresholdOn) {
        this.selectedThreshold = null
        this.formDataObj.threshold_limit = null
      }
    },
    onScheduleSwitchChange () {
      if (!this.isScheduleDateOn) {
        this.schedules = [{
          selectedDay: '',
          selectedTime: ''
        }]
      }
    },
    parseTime (time, format = 'y-m-d h:i:s') {
      if (!time && time !== 0) {
        return '0000-00-00 00:00:00'
      }

      const date = time instanceof Date ? time : new Date(parseInt(time, 10))

      const formatObj = {
        y: date.getFullYear(),
        m: date.getMonth() + 1,
        d: date.getDate(),
        h: date.getHours(),
        i: date.getMinutes(),
        s: date.getSeconds(),
        a: date.getDay()
      }

      return format.replace(/(y|m|d|h|i|s|a)+/gi, (match, p1) => {
        p1 = p1.toLowerCase()
        let value = formatObj[p1]

        if (match.length > 0 && value < 10) {
          value = `0${value}`
        }

        return value || (p1 === 'y' ? '0000' : '00')
      })
    },
    async getCustomerList () {
      return new Promise(resolve => {
        api.buildRequest('getCustomerList', 'POST').then(({ data }) => {
          this.clientList = data.payload.customer
          resolve()
        }).catch(({ response }) => {
          resolve(true)
          this.loading = false
          this.$swal({
            type: 'error',
            text: response ? response.data.payload.message : 'An error occurred'
          })
        })
      })
    },
    async getThresholdList () {
      return new Promise(resolve => {
        api.buildRequest('getThresholdList', 'POST').then(({ data }) => {
          data.payload = data.payload.map(item => {
            item.value = item.id
            item.label = capitalize(item.label.split('_').join(' '))
            return item
          })
          this.ooSsessionThresholdOptions = data.payload.filter(item => !item.opp_is_in_session)
          this.inSessionThresholdOptions = data.payload.filter(item => item.opp_is_in_session)
          resolve()
        }).catch(({ response }) => {
          resolve(true)
          this.loading = false
          this.$swal({
            type: 'error',
            text: response ? response.data.payload.message : 'An error occurred'
          })
        })
      })
    },
    async getAudienceList () {
      return new Promise(resolve => {
        api.buildRequest('getAudienceList', 'POST', { }).then(({ data }) => {
          resolve(data.payload)
        }).catch(({ response }) => {
          resolve([])
          this.loading = false
          this.$swal({
            type: 'error',
            text: response ? response.data.payload.message : 'An error occurred'
          })
        })
      })
    },
    async getNudgesList () {
      try {
        const response = await api.buildRequest(`reengagement/nudges`, 'POST')
        this.nudgesList = response.data.payload.map(nudge => { return { id: nudge.id, label: nudge.msg_template_name, is_dynamic_template: nudge.is_dynamic_template } })
      } catch (error) {
        this.loading = false
        this.$swal({
          type: 'error',
          text: error.response ? error.response.data.payload.message : 'An error occurred'
        })
      }
    },
    isValidURL (url) {
      let urlComp
      try {
        urlComp = new URL(url)
      } catch (err) {
        // if any error occurs while creating URL component for given URL then return false
        // means there is something wrong in given url string
        return false
      }
      // if protocol is https OR http then return true means valid URL
      return urlComp.protocol === 'http:' || urlComp.protocol === 'https:'
    },
    async getDeployedApps (param) {
      try {
        const response = await api.buildRequest(`getDeployedApps`, 'GET', param)
        const apps = []
        for (let app of response.data.payload) {
          apps.push({ id: app.id, label: `${app.appName} - ${this.formatDate(app.updatedAt, 'd/M/Y hh:ss')}` })
        }
        return [...apps]
      } catch (error) {
        this.loading = false
        this.$swal({
          type: 'error',
          text: error.response ? error.response.data.payload.message : 'An error occurred'
        })
      }
    },
    async getConversationAndJourneysAndKeywords () {
      let promiseArr = []
      this.loading = true
      promiseArr.push(this.getDeployedApps({ type: 'CONVERSATION' }), this.getDeployedApps({ type: 'JOURNEY' }), this.getAllKeywords())
      let response = await Promise.all(promiseArr)
      if (this.formDataObj.country_id) {
        this.filteredKeywords = [...this.keywordsList.filter(keyword => keyword.country_id === this.formDataObj.country_id)]
      }
      this.conversationList = response[0]
      this.journeyList = response[1]
      this.loading = false
    },
    async getAllKeywords () {
      return new Promise(resolve => {
        api.buildRequest('getAllKeywords', 'POST').then(({ data }) => {
          this.keywordsList = data.payload.map(item => { return {...item, label: item.keyword} })
          resolve()
        }).catch(({ response }) => {
          resolve(true)
          this.loading = false
          this.$swal({
            type: 'error',
            text: response ? response.data.payload.message : 'An error occurred'
          })
        })
      })
    },
    getTrackedUrls () {
      return new Promise(resolve => {
        api.buildRequest('getTrackedUrls', 'POST').then(({ data }) => {
          this.urlList = data.payload
          resolve()
        }).catch(({ response }) => {
          resolve(true)
          this.loading = false
          this.$swal({
            type: 'error',
            text: response ? response.data.payload.message : 'An error occurred'
          })
        })
      })
    },
    async createOrUpdateOpportunity () {
      let isValidConfigData = this.validateConfigData()
      if (!isValidConfigData) {
        return
      }
      const isValidOpportunity = this.validateOpportunityDetails()
      if (!isValidOpportunity) return

      if (!this.isInSessionOE && this.formDataObj.recurrence === RECURRENCE_TYPE.ONE_TIME) {
        this.loading = false
        await this.$swal({
          type: 'info',
          text: 'If there are more than 250 users then the DBM will be executed in multiple batches of 250 users per 30 mins'
        })
        this.loading = true
      }

      if (this.opportunityAction === 'saveanddeploy') {
        this.formDataObj.opportunity_status = 1
      } else {
        this.formDataObj.opportunity_status = 0
      }

      // If everything is valid then do operation
      const reqParams = this.formatOpportunityRequestData(this.formDataObj)

      if (this.$route.params.opportunityId && !this.$route.params.action) {
        return new Promise(resolve => {
          api.buildRequest('updateOpportunity', 'POST', reqParams).then(({ data }) => {
            if (data.payload.id) {
              this.formDataObj.id = data.payload.id
              this.formDataObj.opportunity_name = data.payload.opportunity_name
              this.$swal({
                type: 'success',
                text: 'Campaign updated successfully'
              }).then(() => {
                this.$router.push({ name: 'opportunity-list' })
              })
              resolve()
              this.loading = false
            } else {
              resolve(true)
              this.loading = false
              this.$swal({
                type: 'error',
                text: data && data.payload && data.payload.message ? data.payload.message : 'An error occurred'
              })
            }
          }).catch(({ response }) => {
            resolve(true)
            this.loading = false
            this.$swal({
              type: 'error',
              text: response ? response.data.payload.message : 'An error occurred'
            })
          })
        })
      } else {
        return new Promise(resolve => {
          api.buildRequest('createOpportunity', 'POST', reqParams).then(({ data }) => {
            if (data.payload.id) {
              this.formDataObj.id = data.payload.id
              this.formDataObj.opportunity_name = data.payload.opportunity_name
              this.$swal({
                type: 'success',
                text: 'Campaign created successfully'
              }).then(() => {
                this.$router.push({ name: 'opportunity-list' })
              })
              resolve()
              this.loading = false
            } else {
              resolve(true)
              this.loading = false
              this.$swal({
                type: 'error',
                text: data && data.payload && data.payload.message ? data.payload.message : 'An error occurred'
              })
            }
          }).catch(({ response }) => {
            resolve(true)
            this.loading = false
            this.$swal({
              type: 'error',
              text: response ? response.data.payload.message : 'An error occurred'
            })
          })
        })
      }
    },
    validateOpportunityDetails () {
      if (this.isInSessionOE) {
        this.validateInSessionInactivityTiming()
      } else if (this.formDataObj.recurrence !== RECURRENCE_TYPE.ONE_TIME) {
        this.validateOutOfSessionInactivityTiming()
      }
      if (this.groupList.length) {
        const sum = this.groupList.reduce((accumulator, object) => {
          return accumulator + Number(object.split_percent)
        }, 0)
        if (sum !== 100) {
          this.$swal({
            type: 'error',
            text: 'Total split percentage should be 100'
          })
          return false
        }
      } else if (!this.isDraft) {
        this.$swal({
          type: 'error',
          text: 'Please add at least one message group to schedule the campaign'
        })
        return false
      }

      this.loading = true
      this.submitted = true
      this.isFormValid = true
      this.messageRequired = false
      this.dateRangeRequired = false
      this.activityCapChoiceRequired = false
      this.maxOffersRequired = false
      this.countryRequired = false
      this.countryRequired = false
      this.messageRequired = false
      this.$v.$touch()

      if (this.$v.$invalid) {
        this.loading = false
        return false
      }

      if (this.isInSessionOE) {
        if (this.isInvalidSendTime || (!this.sendTime.hours && !this.sendTime.minutes)) {
          this.loading = false
          return false
        }
        if (this.scheduleType === 'activitycap') {
          if (!this.activityCapChoice) {
            this.activityCapChoiceRequired = true
            this.isFormValid = false
          } else {
            if (!this.formDataObj.threshold_limit) {
              this.maxOffersRequired = true
              this.isFormValid = false
            }
          }
        }
      } else {
        if (this.formDataObj.recurrence !== RECURRENCE_TYPE.ONE_TIME && (this.isInvalidDelay || (!this.delay.quantity))) {
          this.loading = false
          return false
        }

        if (this.isCampaignThresholdOn) {
          if (!this.selectedThreshold) {
            this.activityCapChoiceRequired = true
            this.isFormValid = false
          }
          if (!this.formDataObj.threshold_limit) {
            this.maxOffersRequired = true
            this.isFormValid = false
          }
        }
      }

      this.groupList.forEach((group, index) => {
        if (!group.message.length || !group.destinationList.length) {
          this.isFormValid = false
        }
        if (group.msg_template_id && !this.checkIfNudgeConfigurationValid(group)) {
          this.isFormValid = false
        }
        if (group.is_intermediate_message || this.isInSessionOE) {
          let item = group.message.find(item => item.language === 'eng')
          if (!item || !item.message) {
            this.isFormValid = false
            this.$swal({
              type: 'error',
              title: 'Message set validation failed',
              text: `English translation(s) are required for Group ${index + 1}`
            })
          }
        }
        group.destinationList.forEach(destination => {
          if ((destination.destinationToUse === 'keyword' && !destination.keyword_id) ||
          (destination.destinationToUse === 'website_link' && !destination.website_link) ||
          (destination.destinationToUse === 'destination_conversation' && !destination.conversation_id)
            ) {
            this.isFormValid = false
          }
        })
      })

      if (!this.isInSessionOE && this.formDataObj.recurrence !== 'ONETIME') {
        let scheduleDict = {}
        if (!this.schedules.length && this.isScheduleDateOn) {
          this.isFormValid = false
          this.$swal({
            type: 'error',
            title: 'No Schedule Found',
            text: `Please select at least one schedule`
          })
        } else {
          this.schedules.forEach(schedule => {
            if (scheduleDict[schedule.selectedDay] && scheduleDict[schedule.selectedDay].includes(schedule.selectedTime)) {
              this.isFormValid = false
              this.$swal({
                type: 'error',
                title: 'Duplicate Schedule Found',
                text: `Duplicate Schedule/s Found at "Day:- ${schedule.selectedDay} & Time: ${schedule.selectedTime}"`
              })
            } else {
              scheduleDict[schedule.selectedDay] = [schedule.selectedTime]
            }
          })
        }
      }

      if (!this.isFormValid) {
        this.loading = false
        return false
      }
      return true
    },
    getUTCDateForTimeZone (date) {
      // Convert Country specific time to UTC
      const time = moment.tz(`${date}`, this.timezone)
      const utcTime = time.utc().format()
      console.log('UTCTime::', utcTime)
      return time.utc().format()
    },
    formatOpportunityRequestData (formDataObj) {
      let action = ''
      if (this.$route && this.$route.params && this.$route.params.action && this.$route.params.action === 'copyOpportunity') {
        action = 'copyOpportunity'
      }
      const detailsObj = {}
      let opportunityId = null
      detailsObj.opportunity_name = formDataObj.opportunity_name ? formDataObj.opportunity_name : null
      detailsObj.country_id = formDataObj.country_id ? formDataObj.country_id : null
      detailsObj.customer_id = formDataObj.customer_id ? formDataObj.customer_id : null
      detailsObj.audience_id = formDataObj.audience_id ? formDataObj.audience_id : null
      detailsObj.conversation_id = formDataObj.conversation_id ? formDataObj.conversation_id : null
      detailsObj.activity_status = formDataObj.activity_status ? formDataObj.activity_status : null
      detailsObj.opportunity_status = formDataObj.opportunity_status
      detailsObj.recurrence = formDataObj.recurrence
      detailsObj.is_in_session = this.isInSessionOE
      detailsObj.is_new_user_batch = formDataObj.isNewUserBatch
      detailsObj.skip_upperbound = formDataObj.skip_upperbound
      if (this.isInSessionOE) {
        detailsObj.lower_inactivity_timing = moment(`${this.sendTime.hours}:${this.sendTime.minutes}`, 'HH:mm').format('HH:mm')
        switch (this.scheduleType) {
          case 'activitycap':
            detailsObj.start_date = null
            detailsObj.end_date = null
            detailsObj.activity_status = null
            detailsObj.threshold_limit = formDataObj.threshold_limit ? formDataObj.threshold_limit : null
            detailsObj.threshold_id = this.activityCapChoice ? this.activityCapChoice : null
            break
          case 'activityStatus':
            detailsObj.threshold_limit = null
            detailsObj.start_date = null
            detailsObj.end_date = null
            detailsObj.threshold_id = null
            break
          case 'daterange':
            detailsObj.start_date = formDataObj.start_date ? this.getUTCDateForTimeZone(formDataObj.start_date) : null
            detailsObj.end_date = formDataObj.end_date ? this.getUTCDateForTimeZone(formDataObj.end_date) : null
            detailsObj.threshold_limit = null
            detailsObj.threshold_id = null
            detailsObj.activity_status = null
            break
        }
        detailsObj.last_reengage_days = null
        detailsObj.max_nudge_per_user = null
      } else {
        if (detailsObj.recurrence === RECURRENCE_TYPE.ONE_TIME) {
          detailsObj.lower_inactivity_timing = null
          detailsObj.max_nudge_per_user = null
        } else {
          detailsObj.lower_inactivity_timing = `${this.delay.units.charAt(0)}:${this.delay.quantity}`
          detailsObj.max_nudge_per_user = formDataObj.max_nudge_per_user ? formDataObj.max_nudge_per_user : null
          if (this.isScheduleDateOn) {
            detailsObj.schedule_config_data = this.schedules
          } else {
            detailsObj.schedule_config_data = null
          }
        }
        detailsObj.destination_conversation = formDataObj.destination_conversation ? this.conversationList.find(ele => ele.id === formDataObj.destination_conversation).label.split(' - ')[0] : null
        if (this.isCampaignThresholdOn) {
          detailsObj.threshold_limit = formDataObj.threshold_limit ? formDataObj.threshold_limit : null
          detailsObj.threshold_id = this.selectedThreshold ? this.selectedThreshold : null
        } else {
          detailsObj.threshold_limit = null
        }
        switch (this.scheduleType) {
          case 'activityStatus':
            detailsObj.start_date = null
            detailsObj.end_date = null
            break
          case 'daterange':
            detailsObj.start_date = formDataObj.start_date ? this.getUTCDateForTimeZone(formDataObj.start_date) : null
            detailsObj.end_date = formDataObj.recurrence === RECURRENCE_TYPE.ONE_TIME ? null : formDataObj.end_date ? this.getUTCDateForTimeZone(formDataObj.end_date) : null
            detailsObj.activity_status = null
            break
          case '': // Occurs when one-time OE is selected in OOS
            detailsObj.start_date = formDataObj.start_date ? this.getUTCDateForTimeZone(formDataObj.start_date) : null
            detailsObj.end_date = null
            detailsObj.activity_status = null
            break
        }
        detailsObj.last_reengage_days = formDataObj.last_reengage_days
      }
      detailsObj.created = new Date()
      detailsObj.updated = new Date()

      if (this.$route && this.$route.params && this.$route.params.opportunityId && !action) {
        delete detailsObj.created
        opportunityId = parseInt(this.$route.params.opportunityId)
        detailsObj.id = opportunityId
      }

      if (action && action === 'copyOpportunity') {
        delete detailsObj.id
      }

      detailsObj.split_type = this.split_type
      const groupData = this.groupList.map((group, index) => {
        let linkData = ''
        const options = group.destinationList.map(destination => {
          if (destination.website_link) {
            const url = this.urlList.find(url => url.id === destination.website_link)
            linkData = linkData + ' ' + this.clickUrlDomain + url.code
          }
          return {
            link_id: destination.website_link ? destination.website_link : null,
            keyword_id: destination.keyword_id,
            destination_conversation_id: destination.conversation_id
          }
        })

        if (group.dynamic_value_configuration) {
          for (const lang of Object.keys(group.dynamic_value_configuration)) {
            if (group.dynamic_value_configuration[lang].header && group.dynamic_value_configuration[lang].header.length === 0) delete group.dynamic_value_configuration[lang].header
            if (group.dynamic_value_configuration[lang].body && group.dynamic_value_configuration[lang].body.length === 0) delete group.dynamic_value_configuration[lang].body
            if (group.dynamic_value_configuration[lang].buttons && group.dynamic_value_configuration[lang].buttons.every(gaps => !gaps || gaps.length === 0)) delete group.dynamic_value_configuration[lang].buttons
          }
        }

        let messages = group.message.filter(msgObj => msgObj.message)
        messages = messages.map(msg => {
          return {
            lang_id: msg.lang_id,
            country_id: msg.country_id,
            message: msg.message + linkData
          }
        })
        return {
          options,
          messages,
          msg_template_id: group.msg_template_id,
          split_percent: group.split_percent,
          dynamic_value_configuration: group.dynamic_value_configuration,
          is_intermediate_message: group.is_intermediate_message,
          group_name: `Group ${index + 1}`
        }
      })

      detailsObj.group_list = groupData
      return detailsObj
    },
    getOpportunityDetails (opportunityId) {
      return new Promise(resolve => {
        api.buildRequest('getOpportunityDetails', 'POST', { id: parseInt(opportunityId) }).then(({ data }) => {
          resolve(data.payload)
        }).catch((err) => {
          resolve(true)
          this.loading = false
          this.$swal({
            type: 'error',
            text: err.response ? err.response.data.payload.message : 'An error occurred'
          })
        })
      })
    },
    async parseOpportunityDetails (opportunityData) {
      this.formDataObj = opportunityData
      const country = Object.keys(this.clientCountries).find(k => this.clientCountries[k] === opportunityData.country_id)
      this.timezone = await this.getTimeZone({ country })
      this.isInSessionOE = opportunityData.is_in_session
      this.opportunityType = opportunityData.is_in_session ? OPPORTUNITY_TYPES.IN_SESSION : OPPORTUNITY_TYPES.OUT_OF_SESSION

      if (opportunityData.is_in_session) {
        if (opportunityData.lower_inactivity_timing) {
          this.sendTime = {
            hours: opportunityData.lower_inactivity_timing.split(':')[0],
            minutes: opportunityData.lower_inactivity_timing.split(':')[1]
          }
        }
        if (opportunityData.threshold_limit) {
          this.scheduleType = 'activitycap'
          this.formDataObj.threshold_limit = opportunityData.threshold_limit
          this.activityCapChoice = opportunityData.threshold_id
        }
        if (opportunityData.start_date && opportunityData.end_date) {
          this.scheduleType = 'daterange'
          this.activityCapChoice = ''
          this.formDataObj.start_date = opportunityData.start_date ? moment.utc(opportunityData.start_date).tz(this.timezone).format('YYYY-MM-DD') : ''
          this.formDataObj.end_date = opportunityData.end_date ? moment.utc(opportunityData.end_date).tz(this.timezone).format('YYYY-MM-DD') : ''
        }
      } else {
        if (opportunityData.lower_inactivity_timing) {
          this.delay = {
            quantity: opportunityData.lower_inactivity_timing.split(':')[1],
            units: (opportunityData.lower_inactivity_timing.split(':')[0] === 'h' ? 'hrs' : 'days')
          }
        }
        if (opportunityData.destination_conversation) {
          this.formDataObj.destination_conversation = this.conversationList.find(ele => ele.label.split(' - ')[0] === opportunityData.destination_conversation).id
        }
        if (opportunityData.threshold_id) {
          this.isCampaignThresholdOn = true
          this.formDataObj.threshold_limit = opportunityData.threshold_limit
          this.selectedThreshold = opportunityData.threshold_id
        }

        if (opportunityData.recurrence === RECURRENCE_TYPE.ONE_TIME) {
          if (opportunityData.start_date) {
            this.scheduleType = ''
            this.formDataObj.start_date = opportunityData.start_date ? moment.utc(opportunityData.start_date).tz(this.timezone).format('YYYY-MM-DDTHH:mm:ss') : ''
          }
        } else {
          if (opportunityData.start_date && opportunityData.end_date) {
            this.scheduleType = 'daterange'
            this.formDataObj.start_date = opportunityData.start_date ? moment.utc(opportunityData.start_date).tz(this.timezone).format('YYYY-MM-DDTHH:mm:ss') : ''
            this.formDataObj.end_date = opportunityData.end_date ? moment.utc(opportunityData.end_date).tz(this.timezone).format('YYYY-MM-DDTHH:mm:ss') : ''
          }
          if (Array.isArray(opportunityData.schedule_config_data) && opportunityData.schedule_config_data.length > 0) {
            this.schedules = opportunityData.schedule_config_data
            this.isScheduleDateOn = true
          }
        }

        if (opportunityData.is_new_user_batch) {
          this.formDataObj.isNewUserBatch = opportunityData.is_new_user_batch
        }

        if (opportunityData.skip_upperbound) {
          this.formDataObj.skip_upperbound = opportunityData.skip_upperbound
        }
      }

      if (opportunityData.activity_status) {
        this.scheduleType = 'activityStatus'
        if (opportunityData.activity_status === 'PAUSE') this.toggleactivityStatus = false
      } else {
        // Restore initial state
        this.formDataObj.activity_status = 'ACTIVE'
      }

      if (this.$route.params.action && this.$route.params.action === 'copyOpportunity') {
        this.formDataObj.opportunity_status = 0
      }
      if (opportunityData.audience_id) {
        this.selectedAudienceType = 'audience'
        this.formDataObj.conversation_id = ''
      }
      if (opportunityData.conversation_id) {
        this.selectedAudienceType = 'journey'
        this.formDataObj.audience_id = ''
      }
      if (opportunityData.split_type) {
        this.split_type = opportunityData.split_type
      }
      this.groupList = opportunityData.group_list.map(group => {
        group.destinationList.forEach(option => {
          if (!option.website_link) option.website_link = ''
          // Updating key to conversation_id as we have now removed destination_conversation_id from frontend. Done this for OOS OE Destination_conversation field
          option.conversation_id = option.destination_conversation_id
          delete option.destination_conversation_id
        })

        const country = Object.keys(this.clientCountries).find(k => this.clientCountries[k] === opportunityData.country_id)
        this.getLanguagesInCountry(country)

        let groupMessage = []
        this.languages.forEach(lang => {
          let currentMsgObj = group.message.find(item => opportunityData.country_id === lang.country_id && item.lang_id === lang.lang_id)
          groupMessage.push({
            message: currentMsgObj ? currentMsgObj.message : '',
            country_id: lang.country_id,
            lang_id: lang.lang_id,
            language: lang.alias,
            country: lang.country
          })
        })
        group.message = groupMessage

        return {
          ...group,
          selectedCountry: '',
          messageLanguage: '',
          messageText: ''
        }
      })
    },
    closeNudgePreview () {
      this.groupList[this.previewGroupIndex].dynamic_value_configuration = this.currentGroupListDynamicValue
      this.showNudgePreview = false
      this.pendingNudgePreview = null
    },
    saveConfiguredNudgeData () {
      if (!this.checkIfNudgeConfigurationValid(this.groupList[this.previewGroupIndex])) {
        this.$swal({
          type: 'error',
          text: 'Please enter data in all the fields'
        })
        return
      }
      let lengthExceedErrors = []
      this.nudgePreviewData.forEach(nudge => {
        let header = nudge.headerObj.content
        nudge.headerObj.gaps && nudge.headerObj.gaps.forEach(gap => {
          header = header.replace(/{{(.+?)}}/, gap)
        })
        if (header && header.length > 60) {
          lengthExceedErrors.push(`Header length should not exceed the total limit of 60 characters for ${nudge.language}`)
        }

        let body = nudge.bodyObj.content
        nudge.bodyObj.gaps && nudge.bodyObj.gaps.forEach(gap => {
          body = body.replace(/{{(.+?)}}/, gap)
        })
        if (body && body.length > 1024) {
          lengthExceedErrors.push(`Body length should not exceed the total limit of 1024 characters for ${nudge.language}`)
        }

        nudge.buttonsObj && nudge.buttonsObj.forEach((buttonObj, bIndex) => {
          let url = buttonObj.content
          if (!url) return
          buttonObj.gaps && buttonObj.gaps.forEach(gap => {
            url = url.replace(/{{(.+?)}}/, gap)
          })
          if (url.length > 2000) {
            lengthExceedErrors.push(`Button ${bIndex + 1} URL length should not exceed the total limit of 2000 characters for ${nudge.language}`)
          }
        })
      })
      if (lengthExceedErrors.length) {
        this.$swal({
          type: 'error',
          text: lengthExceedErrors.join('\n')
        })
        return
      }
      this.showNudgePreview = false
    },
    onNudgechange (group, nudgeId) {
      group.dynamic_value_configuration = null
    },
    trimMoreThan4Spaces (event) {
      const regex = /\s{5,}/g
      const replacement = '    ' // 4 spaces
      event.target.value = event.target.value.replace(regex, replacement)
    },
    isDynamicTemplate (nudgeId) {
      let templateObj = this.nudgesList.find(item => item.id === nudgeId)
      return templateObj && templateObj.is_dynamic_template
    },
    // Grows/shrinks a shared gaps array in place to match the current template's
    // placeholder count, without losing the values already entered by the user.
    resizeGapsInPlace (gaps, length) {
      while (gaps.length < length) gaps.push('')
      gaps.length = length
    },
    checkIfNudgeConfigurationValid (group) {
      if (this.isDynamicTemplate(group.msg_template_id)) {
        if (!group.dynamic_value_configuration) return false
        for (const contentData of Object.values(group.dynamic_value_configuration)) {
          for (const tokens of Object.values(contentData)) {
            // "buttons" is an array of per-button gap arrays, so flatten it before checking
            for (let item of tokens.flat()) {
              if (!item) return false
            }
          }
        }
      }
      return true
    },
    async getTurnCountryList () {
      if (this.turnCountryList.length) return
      try {
        const response = await api.buildRequest('getQuickLinkConfig', 'POST')
        const whatsapp = (response.data.payload && response.data.payload.whatsapp) || {}
        this.turnCountryList = Object.keys(whatsapp)
      } catch (error) {
        console.error('Failed to fetch WhatsApp country list', error)
      }
    },
    onTurnCountryChange () {
      if (this.turnCountry) {
        this.showCountryPicker = false
        if (this.pendingNudgePreview) this.loadNudgePreview()
      }
    },
    /**
     * @description opens the preview/configure popup on the country picked earlier while
     * editing this opportunity, and asks for one when there is no usable choice yet. The
     * country is kept in component state only, so it resets on a page change or refresh.
     */
    async onNudgePreviewClick (groupIndex, nudge) {
      this.pendingNudgePreview = { groupIndex, nudge }
      this.nudgePreviewData = []
      this.previewGroupIndex = groupIndex
      // Keep the current dynamic values so closing without picking restores them unchanged
      this.currentGroupListDynamicValue = this.groupList[groupIndex].dynamic_value_configuration
        ? JSON.parse(JSON.stringify(this.groupList[groupIndex].dynamic_value_configuration))
        : this.groupList[groupIndex].dynamic_value_configuration
      this.loading = true
      await this.getTurnCountryList()
      if (!this.turnCountryList.includes(this.turnCountry)) this.turnCountry = ''
      this.showCountryPicker = !this.turnCountry
      this.loading = false
      this.showNudgePreview = true
      if (this.turnCountry) this.loadNudgePreview()
    },
    async loadNudgePreview () {
      const { groupIndex, nudge } = this.pendingNudgePreview
      try {
        this.loading = true
        const response = await api.buildRequest(`getNudgePreview`, 'GET', { nudge: this.nudgesList.find(item => item.id === nudge).label, country: this.turnCountry })
        this.showNudgePreview = true
        this.previewGroupIndex = groupIndex
        let reg = /\{\{.*?\}\}/g
        if (this.isDynamicTemplate(nudge) && (!this.groupList[groupIndex].dynamic_value_configuration)) {
          this.groupList[groupIndex].dynamic_value_configuration = {}
        }

        response.data.payload.forEach(item => {
          const turnTemplateData = item.turn_template_data || {}
          item.headerObj = {
            content: turnTemplateData.HEADER,
            gaps: [],
            text: [],
            last: ''
          }
          if (item.is_dynamic_template && turnTemplateData.HEADER) {
            let text = turnTemplateData.HEADER.split(reg)
            item.headerObj.last = text.pop()
            text.forEach((part, i) => {
              item.headerObj.gaps.push('')
            })
            item.headerObj.text = text
          } else {
            item.headerObj.last = turnTemplateData.HEADER
          }

          item.bodyObj = {
            content: (turnTemplateData.BODY || '').trim(),
            gaps: [],
            text: [],
            last: ''
          }
          if (item.is_dynamic_template && turnTemplateData.BODY) {
            let text = turnTemplateData.BODY.trim().split(reg)
            item.bodyObj.last = text.pop()
            text.forEach((part, i) => {
              item.bodyObj.gaps.push('')
            })
            item.bodyObj.text = text
          } else {
            item.bodyObj.last = turnTemplateData.BODY
          }

          // A button (e.g. a URL button) can also carry a dynamic {{n}} token, not just header/body.
          item.buttonsObj = (turnTemplateData.BUTTONS || []).map(button => {
            const buttonObj = {
              label: button && button.text,
              content: button && button.url,
              gaps: [],
              text: [],
              last: button && button.text
            }
            if (item.is_dynamic_template && button && button.type === 'URL' && button.url) {
              let text = button.url.split(reg)
              buttonObj.last = text.pop()
              text.forEach((part, i) => {
                buttonObj.gaps.push('')
              })
              buttonObj.text = text
            }
            return buttonObj
          })

          if (this.groupList[groupIndex].dynamic_value_configuration) {
            if (this.groupList[groupIndex].dynamic_value_configuration[item.lang]) {
              const savedConfig = this.groupList[groupIndex].dynamic_value_configuration[item.lang]
              // Reuse the same array (not a copy) so editing the value for one country's
              // preview updates it for every other country too - it's one shared value.
              if (!Array.isArray(savedConfig.header)) savedConfig.header = item.headerObj.gaps
              this.resizeGapsInPlace(savedConfig.header, item.headerObj.text.length)
              item.headerObj.gaps = savedConfig.header

              if (!Array.isArray(savedConfig.body)) savedConfig.body = item.bodyObj.gaps
              this.resizeGapsInPlace(savedConfig.body, item.bodyObj.text.length)
              item.bodyObj.gaps = savedConfig.body

              if (!Array.isArray(savedConfig.buttons)) savedConfig.buttons = item.buttonsObj.map(buttonObj => buttonObj.gaps)
              item.buttonsObj.forEach((buttonObj, bIndex) => {
                if (!Array.isArray(savedConfig.buttons[bIndex])) savedConfig.buttons[bIndex] = buttonObj.gaps
                this.resizeGapsInPlace(savedConfig.buttons[bIndex], buttonObj.text.length)
                buttonObj.gaps = savedConfig.buttons[bIndex]
              })
            } else {
              this.groupList[groupIndex].dynamic_value_configuration[item.lang] = {}
              this.groupList[groupIndex].dynamic_value_configuration[item.lang].header = item.headerObj.gaps
              this.groupList[groupIndex].dynamic_value_configuration[item.lang].body = item.bodyObj.gaps
              this.groupList[groupIndex].dynamic_value_configuration[item.lang].buttons = item.buttonsObj.map(buttonObj => buttonObj.gaps)
            }
          }
        })

        this.currentGroupListDynamicValue = JSON.parse(JSON.stringify(this.groupList[groupIndex].dynamic_value_configuration))

        this.nudgePreviewData = response.data.payload
        this.loading = false
      } catch (error) {
        console.log(error)
        this.nudgePreviewData = []
        this.loading = false
        this.$swal({
          type: 'error',
          text: error.response ? error.response.data.payload.message : 'An error occurred'
        })
      }
    }
  },
  async mounted () {
    var domainname = window.location.hostname
    this.clickUrlDomain = domain[domainname].clickUrlDomain
    this.loading = true
    this.actionToBePerformed = 'Create Opportunity'
    if (this.$route && this.$route.params && this.$route.params.opportunityId && this.$route.params.action) {
      this.actionToBePerformed = 'Create Opportunity'
    }
    if (this.$route && this.$route.params && this.$route.params.opportunityId && !this.$route.params.action) {
      this.actionToBePerformed = 'Update Opportunity'
    }
    this.setNewSplitData()
    this.getSupportedCountriesLanguages()
    this.journeyList = await this.getDeployedApps({ type: 'JOURNEY' })
    this.journeyList = orderBy(this.journeyList, [convo => convo.label.toLowerCase()], 'asc')
    this.conversationList = await this.getDeployedApps({ type: 'CONVERSATION' })
    this.conversationList = [...this.conversationList, ...this.journeyList]
    this.conversationList = orderBy(this.conversationList, [convo => convo.label.toLowerCase()], 'asc')
    this.getTrackedUrls()
    this.getAllKeywords()
    this.getCustomerList()
    this.getThresholdList()
    this.audienceList = await this.getAudienceList()

    this.getNudgesList()

    if (this.$route && this.$route.params && this.$route.params.opportunityId) {
      const opportunityData = await this.getOpportunityDetails(this.$route.params.opportunityId)
      const country = Object.keys(this.clientCountries).find(k => this.clientCountries[k] === opportunityData.country_id)
      this.timezone = await this.getTimeZone({ country: country })
      await this.parseOpportunityDetails(opportunityData)
      if (this.formDataObj.country_id) {
        this.filteredKeywords = [...this.keywordsList.filter(keyword => keyword.country_id === this.formDataObj.country_id)]
        this.filteredAudienceList = [...this.audienceList.filter(audience => audience.country_id === this.formDataObj.country_id)]
        this.filteredClientList = [...this.clientList.filter(client => (client.country_id === this.formDataObj.country_id || client.country_id === null) && client.is_deleted === false)]
      }
    }
    this.loading = false
  },
  computed: {
    isOETypeDisabled () {
      return (this.actionToBePerformed === 'Update Opportunity' || (this.$route && this.$route.params && this.$route.params.action && this.$route.params.action === 'copyOpportunity'))
    }
  }
}
</script>

<style>
.vue-input {
  max-width: 80px;
}
.input-wrapper {
  width: fit-content;
  display: flex;
  justify-content: space-between;
}
.message {
  overflow: auto;
  max-height: 200px;
  max-width: 400px;
}
.text-wrap {
  white-space: pre-wrap;
}
.paddingTop7px {
  padding-top: 7px;
}
.text-underline {
  text-decoration: underline;    
}
.padding10px {
  padding: 10px;
}
.v-autocomplete {
  position:relative;
}
.v-autocomplete-input {
  padding:10px 15px;
  height:34px;
}
.v-autocomplete-list {
  width:calc(100% - 30px);
  border:1px solid #d2d6de;
  position:absolute;
  top:58px;
  z-index:111;
  list-style: none;
  padding: 0%;
  max-height: 110%;
  overflow: overlay;
}
.v-autocomplete-list-formatted {
  width:calc(100% - 0px);
  border:1px solid #d2d6de;
  position:absolute;
  top:33px;
  z-index:111;
  list-style: none;
  padding: 0%;
  max-height: 587%;  
  overflow: overlay;
}
.v-autocomplete-list-item {
  width:100%;
  border-bottom:1px solid #d2d6de;
  padding:6px 12px;
  font-size:14px;
  background-color:white;
  cursor:pointer;
}
.v-autocomplete-list-item:last-child {
  width:100%;
  border-bottom:none;
}
.v-autocomplete-list-item:hover {
  background-color: #d2d6de;
}
.website_link {
  margin-top:5px;
  margin-bottom:10px;
}
.margin-top-5px {
  margin-top:5px;
}
.margin-bottom-10px {
  margin-bottom:10px;
}
.audience-or-journey {
  font-weight: bold;
  position: absolute;
  width: inherit;
  margin-left: -15px;
  margin-top: 5px;
  text-align: center;
  z-index: 0;
}
.btn-save-preview {
  margin-right: 10px;
  margin-bottom: 30px;
}
.destination-button{
  margin-top: 2rem;
  margin-left: -3rem;
}
.oe-content-container {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  min-height: 100%;  
  flex-grow: 1;
}
.oe-action-buttons {
  margin: 10px;
}
.campaign-goals-header {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: center;
}
.goals-container {
  display: flex;
  justify-content: space-evenly;
}

</style>

<style scoped>
.hint-text {
  color:#ff7890;
  font-size:14px;
}
.collapsable-link-panel {
  display: block;
  padding: 10px;
  width: 100%;
  border-color: transparent;
}
.collapsable-link-panel-child {
  background: #0D9488;
}
.panel-primary {
  border-color: #0D9488
}
.panel-primary > .panel-heading {
  border-color: #0D9488
}
.fixed-table {
  width: 100%;
  table-layout: fixed;
  border-spacing: revert;
  border-collapse: revert;
  border: 2px solid pink;
  border-radius: 5px;
}
.message-title {
  display: flex;
  justify-content: space-between;
}
.message-country {
  width: 100px; 
  background-color: #e8e8e8;
  text-align: center;
}
.message-language {
  width:70px; 
  background-color: #f3f2f2;
  text-align: center;
}
.collapse-style {
  width:100%; 
  padding: 10px;
}
.expand-style {
  width:100%; 
  padding: 10px;
  height: '';
}
.icon-padding {
  padding: 5px;
}
.clear-translation {
  width: 15px;
  padding: 4px;
}
.message-set-container {
  margin-bottom: 20px;
  margin-right: 15px;
  margin-left: 15px;
}
.reload-dbm {
  display: flex;
  align-items: center;
  justify-content: center;
}
.reload-dbm-conversation {
  display: flex;
  align-items: center;
  justify-content: center;
}
.fa-refresh:before {
  margin-left: 15px;
  align-items: center;
  justify-content: center;
}
.style-title {
  display: flex;
}
.modal-body {
  position: relative;
  min-height: 315px;    
}
</style>


// WEBPACK FOOTER //
// createOrUpdateOpportunity.vue?c568e440